(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported'); 
  });
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/localforage/dist/localforage.js
  var require_localforage = __commonJS({
    "node_modules/localforage/dist/localforage.js"(exports, module) {
      /*!
          localForage -- Offline Storage, Improved
          Version 1.10.0
          https://localforage.github.io/localForage
          (c) 2013-2017 Mozilla, Apache License 2.0
      */
      (function(f) {
        if (typeof exports === "object" && typeof module !== "undefined") {
          module.exports = f();
        } else if (typeof define === "function" && define.amd) {
          define([], f);
        } else {
          var g;
          if (typeof window !== "undefined") {
            g = window;
          } else if (typeof global !== "undefined") {
            g = global;
          } else if (typeof self !== "undefined") {
            g = self;
          } else {
            g = this;
          }
          g.localforage = f();
        }
      })(function() {
        var define2, module2, exports2;
        return function e(t, n, r) {
          function s(o2, u) {
            if (!n[o2]) {
              if (!t[o2]) {
                var a = typeof __require == "function" && __require;
                if (!u && a)
                  return a(o2, true);
                if (i)
                  return i(o2, true);
                var f = new Error("Cannot find module '" + o2 + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
              }
              var l = n[o2] = { exports: {} };
              t[o2][0].call(l.exports, function(e2) {
                var n2 = t[o2][1][e2];
                return s(n2 ? n2 : e2);
              }, l, l.exports, e, t, n, r);
            }
            return n[o2].exports;
          }
          var i = typeof __require == "function" && __require;
          for (var o = 0; o < r.length; o++)
            s(r[o]);
          return s;
        }({ 1: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
            var scheduleDrain;
            {
              if (Mutation) {
                var called = 0;
                var observer = new Mutation(nextTick);
                var element = global2.document.createTextNode("");
                observer.observe(element, {
                  characterData: true
                });
                scheduleDrain = function() {
                  element.data = called = ++called % 2;
                };
              } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
                var channel = new global2.MessageChannel();
                channel.port1.onmessage = nextTick;
                scheduleDrain = function() {
                  channel.port2.postMessage(0);
                };
              } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
                scheduleDrain = function() {
                  var scriptEl = global2.document.createElement("script");
                  scriptEl.onreadystatechange = function() {
                    nextTick();
                    scriptEl.onreadystatechange = null;
                    scriptEl.parentNode.removeChild(scriptEl);
                    scriptEl = null;
                  };
                  global2.document.documentElement.appendChild(scriptEl);
                };
              } else {
                scheduleDrain = function() {
                  setTimeout(nextTick, 0);
                };
              }
            }
            var draining;
            var queue = [];
            function nextTick() {
              draining = true;
              var i, oldQueue;
              var len = queue.length;
              while (len) {
                oldQueue = queue;
                queue = [];
                i = -1;
                while (++i < len) {
                  oldQueue[i]();
                }
                len = queue.length;
              }
              draining = false;
            }
            module3.exports = immediate;
            function immediate(task) {
              if (queue.push(task) === 1 && !draining) {
                scheduleDrain();
              }
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, {}], 2: [function(_dereq_, module3, exports3) {
          "use strict";
          var immediate = _dereq_(1);
          function INTERNAL() {
          }
          var handlers = {};
          var REJECTED = ["REJECTED"];
          var FULFILLED = ["FULFILLED"];
          var PENDING = ["PENDING"];
          module3.exports = Promise2;
          function Promise2(resolver) {
            if (typeof resolver !== "function") {
              throw new TypeError("resolver must be a function");
            }
            this.state = PENDING;
            this.queue = [];
            this.outcome = void 0;
            if (resolver !== INTERNAL) {
              safelyResolveThenable(this, resolver);
            }
          }
          Promise2.prototype["catch"] = function(onRejected) {
            return this.then(null, onRejected);
          };
          Promise2.prototype.then = function(onFulfilled, onRejected) {
            if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
              return this;
            }
            var promise = new this.constructor(INTERNAL);
            if (this.state !== PENDING) {
              var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
              unwrap(promise, resolver, this.outcome);
            } else {
              this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
            }
            return promise;
          };
          function QueueItem(promise, onFulfilled, onRejected) {
            this.promise = promise;
            if (typeof onFulfilled === "function") {
              this.onFulfilled = onFulfilled;
              this.callFulfilled = this.otherCallFulfilled;
            }
            if (typeof onRejected === "function") {
              this.onRejected = onRejected;
              this.callRejected = this.otherCallRejected;
            }
          }
          QueueItem.prototype.callFulfilled = function(value) {
            handlers.resolve(this.promise, value);
          };
          QueueItem.prototype.otherCallFulfilled = function(value) {
            unwrap(this.promise, this.onFulfilled, value);
          };
          QueueItem.prototype.callRejected = function(value) {
            handlers.reject(this.promise, value);
          };
          QueueItem.prototype.otherCallRejected = function(value) {
            unwrap(this.promise, this.onRejected, value);
          };
          function unwrap(promise, func, value) {
            immediate(function() {
              var returnValue;
              try {
                returnValue = func(value);
              } catch (e) {
                return handlers.reject(promise, e);
              }
              if (returnValue === promise) {
                handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
              } else {
                handlers.resolve(promise, returnValue);
              }
            });
          }
          handlers.resolve = function(self2, value) {
            var result = tryCatch(getThen, value);
            if (result.status === "error") {
              return handlers.reject(self2, result.value);
            }
            var thenable = result.value;
            if (thenable) {
              safelyResolveThenable(self2, thenable);
            } else {
              self2.state = FULFILLED;
              self2.outcome = value;
              var i = -1;
              var len = self2.queue.length;
              while (++i < len) {
                self2.queue[i].callFulfilled(value);
              }
            }
            return self2;
          };
          handlers.reject = function(self2, error) {
            self2.state = REJECTED;
            self2.outcome = error;
            var i = -1;
            var len = self2.queue.length;
            while (++i < len) {
              self2.queue[i].callRejected(error);
            }
            return self2;
          };
          function getThen(obj) {
            var then = obj && obj.then;
            if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") {
              return function appyThen() {
                then.apply(obj, arguments);
              };
            }
          }
          function safelyResolveThenable(self2, thenable) {
            var called = false;
            function onError(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.reject(self2, value);
            }
            function onSuccess(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.resolve(self2, value);
            }
            function tryToUnwrap() {
              thenable(onSuccess, onError);
            }
            var result = tryCatch(tryToUnwrap);
            if (result.status === "error") {
              onError(result.value);
            }
          }
          function tryCatch(func, value) {
            var out = {};
            try {
              out.value = func(value);
              out.status = "success";
            } catch (e) {
              out.status = "error";
              out.value = e;
            }
            return out;
          }
          Promise2.resolve = resolve;
          function resolve(value) {
            if (value instanceof this) {
              return value;
            }
            return handlers.resolve(new this(INTERNAL), value);
          }
          Promise2.reject = reject;
          function reject(reason) {
            var promise = new this(INTERNAL);
            return handlers.reject(promise, reason);
          }
          Promise2.all = all;
          function all(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var values = new Array(len);
            var resolved = 0;
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              allResolver(iterable[i], i);
            }
            return promise;
            function allResolver(value, i2) {
              self2.resolve(value).then(resolveFromAll, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
              function resolveFromAll(outValue) {
                values[i2] = outValue;
                if (++resolved === len && !called) {
                  called = true;
                  handlers.resolve(promise, values);
                }
              }
            }
          }
          Promise2.race = race;
          function race(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              resolver(iterable[i]);
            }
            return promise;
            function resolver(value) {
              self2.resolve(value).then(function(response) {
                if (!called) {
                  called = true;
                  handlers.resolve(promise, response);
                }
              }, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
            }
          }
        }, { "1": 1 }], 3: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            if (typeof global2.Promise !== "function") {
              global2.Promise = _dereq_(2);
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, { "2": 2 }], 4: [function(_dereq_, module3, exports3) {
          "use strict";
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function getIDB() {
            try {
              if (typeof indexedDB !== "undefined") {
                return indexedDB;
              }
              if (typeof webkitIndexedDB !== "undefined") {
                return webkitIndexedDB;
              }
              if (typeof mozIndexedDB !== "undefined") {
                return mozIndexedDB;
              }
              if (typeof OIndexedDB !== "undefined") {
                return OIndexedDB;
              }
              if (typeof msIndexedDB !== "undefined") {
                return msIndexedDB;
              }
            } catch (e) {
              return;
            }
          }
          var idb = getIDB();
          function isIndexedDBValid() {
            try {
              if (!idb || !idb.open) {
                return false;
              }
              var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
              var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
              return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
              // and HTC Android devices <4.4 are missing IDBKeyRange
              // See: https://github.com/mozilla/localForage/issues/128
              // See: https://github.com/mozilla/localForage/issues/272
              typeof IDBKeyRange !== "undefined";
            } catch (e) {
              return false;
            }
          }
          function createBlob(parts, properties) {
            parts = parts || [];
            properties = properties || {};
            try {
              return new Blob(parts, properties);
            } catch (e) {
              if (e.name !== "TypeError") {
                throw e;
              }
              var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
              var builder = new Builder();
              for (var i = 0; i < parts.length; i += 1) {
                builder.append(parts[i]);
              }
              return builder.getBlob(properties.type);
            }
          }
          if (typeof Promise === "undefined") {
            _dereq_(3);
          }
          var Promise$1 = Promise;
          function executeCallback(promise, callback) {
            if (callback) {
              promise.then(function(result) {
                callback(null, result);
              }, function(error) {
                callback(error);
              });
            }
          }
          function executeTwoCallbacks(promise, callback, errorCallback) {
            if (typeof callback === "function") {
              promise.then(callback);
            }
            if (typeof errorCallback === "function") {
              promise["catch"](errorCallback);
            }
          }
          function normalizeKey(key2) {
            if (typeof key2 !== "string") {
              console.warn(key2 + " used as a key, but it is not a string.");
              key2 = String(key2);
            }
            return key2;
          }
          function getCallback() {
            if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
              return arguments[arguments.length - 1];
            }
          }
          var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
          var supportsBlobs = void 0;
          var dbContexts = {};
          var toString = Object.prototype.toString;
          var READ_ONLY = "readonly";
          var READ_WRITE = "readwrite";
          function _binStringToArrayBuffer(bin) {
            var length2 = bin.length;
            var buf = new ArrayBuffer(length2);
            var arr = new Uint8Array(buf);
            for (var i = 0; i < length2; i++) {
              arr[i] = bin.charCodeAt(i);
            }
            return buf;
          }
          function _checkBlobSupportWithoutCaching(idb2) {
            return new Promise$1(function(resolve) {
              var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
              var blob = createBlob([""]);
              txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
              txn.onabort = function(e) {
                e.preventDefault();
                e.stopPropagation();
                resolve(false);
              };
              txn.oncomplete = function() {
                var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                var matchedEdge = navigator.userAgent.match(/Edge\//);
                resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
              };
            })["catch"](function() {
              return false;
            });
          }
          function _checkBlobSupport(idb2) {
            if (typeof supportsBlobs === "boolean") {
              return Promise$1.resolve(supportsBlobs);
            }
            return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
              supportsBlobs = value;
              return supportsBlobs;
            });
          }
          function _deferReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = {};
            deferredOperation.promise = new Promise$1(function(resolve, reject) {
              deferredOperation.resolve = resolve;
              deferredOperation.reject = reject;
            });
            dbContext.deferredOperations.push(deferredOperation);
            if (!dbContext.dbReady) {
              dbContext.dbReady = deferredOperation.promise;
            } else {
              dbContext.dbReady = dbContext.dbReady.then(function() {
                return deferredOperation.promise;
              });
            }
          }
          function _advanceReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.resolve();
              return deferredOperation.promise;
            }
          }
          function _rejectReadiness(dbInfo, err) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.reject(err);
              return deferredOperation.promise;
            }
          }
          function _getConnection(dbInfo, upgradeNeeded) {
            return new Promise$1(function(resolve, reject) {
              dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
              if (dbInfo.db) {
                if (upgradeNeeded) {
                  _deferReadiness(dbInfo);
                  dbInfo.db.close();
                } else {
                  return resolve(dbInfo.db);
                }
              }
              var dbArgs = [dbInfo.name];
              if (upgradeNeeded) {
                dbArgs.push(dbInfo.version);
              }
              var openreq = idb.open.apply(idb, dbArgs);
              if (upgradeNeeded) {
                openreq.onupgradeneeded = function(e) {
                  var db = openreq.result;
                  try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                      db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                  } catch (ex) {
                    if (ex.name === "ConstraintError") {
                      console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                      throw ex;
                    }
                  }
                };
              }
              openreq.onerror = function(e) {
                e.preventDefault();
                reject(openreq.error);
              };
              openreq.onsuccess = function() {
                var db = openreq.result;
                db.onversionchange = function(e) {
                  e.target.close();
                };
                resolve(db);
                _advanceReadiness(dbInfo);
              };
            });
          }
          function _getOriginalConnection(dbInfo) {
            return _getConnection(dbInfo, false);
          }
          function _getUpgradedConnection(dbInfo) {
            return _getConnection(dbInfo, true);
          }
          function _isUpgradeNeeded(dbInfo, defaultVersion) {
            if (!dbInfo.db) {
              return true;
            }
            var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
            var isDowngrade = dbInfo.version < dbInfo.db.version;
            var isUpgrade = dbInfo.version > dbInfo.db.version;
            if (isDowngrade) {
              if (dbInfo.version !== defaultVersion) {
                console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
              }
              dbInfo.version = dbInfo.db.version;
            }
            if (isUpgrade || isNewStore) {
              if (isNewStore) {
                var incVersion = dbInfo.db.version + 1;
                if (incVersion > dbInfo.version) {
                  dbInfo.version = incVersion;
                }
              }
              return true;
            }
            return false;
          }
          function _encodeBlob(blob) {
            return new Promise$1(function(resolve, reject) {
              var reader = new FileReader();
              reader.onerror = reject;
              reader.onloadend = function(e) {
                var base64 = btoa(e.target.result || "");
                resolve({
                  __local_forage_encoded_blob: true,
                  data: base64,
                  type: blob.type
                });
              };
              reader.readAsBinaryString(blob);
            });
          }
          function _decodeBlob(encodedBlob) {
            var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
            return createBlob([arrayBuff], { type: encodedBlob.type });
          }
          function _isEncodedBlob(value) {
            return value && value.__local_forage_encoded_blob;
          }
          function _fullyReady(callback) {
            var self2 = this;
            var promise = self2._initReady().then(function() {
              var dbContext = dbContexts[self2._dbInfo.name];
              if (dbContext && dbContext.dbReady) {
                return dbContext.dbReady;
              }
            });
            executeTwoCallbacks(promise, callback, callback);
            return promise;
          }
          function _tryReconnect(dbInfo) {
            _deferReadiness(dbInfo);
            var dbContext = dbContexts[dbInfo.name];
            var forages = dbContext.forages;
            for (var i = 0; i < forages.length; i++) {
              var forage = forages[i];
              if (forage._dbInfo.db) {
                forage._dbInfo.db.close();
                forage._dbInfo.db = null;
              }
            }
            dbInfo.db = null;
            return _getOriginalConnection(dbInfo).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              for (var i2 = 0; i2 < forages.length; i2++) {
                forages[i2]._dbInfo.db = db;
              }
            })["catch"](function(err) {
              _rejectReadiness(dbInfo, err);
              throw err;
            });
          }
          function createTransaction(dbInfo, mode, callback, retries) {
            if (retries === void 0) {
              retries = 1;
            }
            try {
              var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
              callback(null, tx);
            } catch (err) {
              if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
                return Promise$1.resolve().then(function() {
                  if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    if (dbInfo.db) {
                      dbInfo.version = dbInfo.db.version + 1;
                    }
                    return _getUpgradedConnection(dbInfo);
                  }
                }).then(function() {
                  return _tryReconnect(dbInfo).then(function() {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                  });
                })["catch"](callback);
              }
              callback(err);
            }
          }
          function createDbContext() {
            return {
              // Running localForages sharing a database.
              forages: [],
              // Shared database.
              db: null,
              // Database readiness (promise).
              dbReady: null,
              // Deferred operations on the database.
              deferredOperations: []
            };
          }
          function _initStorage(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            var dbContext = dbContexts[dbInfo.name];
            if (!dbContext) {
              dbContext = createDbContext();
              dbContexts[dbInfo.name] = dbContext;
            }
            dbContext.forages.push(self2);
            if (!self2._initReady) {
              self2._initReady = self2.ready;
              self2.ready = _fullyReady;
            }
            var initPromises = [];
            function ignoreErrors() {
              return Promise$1.resolve();
            }
            for (var j = 0; j < dbContext.forages.length; j++) {
              var forage = dbContext.forages[j];
              if (forage !== self2) {
                initPromises.push(forage._initReady()["catch"](ignoreErrors));
              }
            }
            var forages = dbContext.forages.slice(0);
            return Promise$1.all(initPromises).then(function() {
              dbInfo.db = dbContext.db;
              return _getOriginalConnection(dbInfo);
            }).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              self2._dbInfo = dbInfo;
              for (var k = 0; k < forages.length; k++) {
                var forage2 = forages[k];
                if (forage2 !== self2) {
                  forage2._dbInfo.db = dbInfo.db;
                  forage2._dbInfo.version = dbInfo.version;
                }
              }
            });
          }
          function getItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.get(key2);
                    req.onsuccess = function() {
                      var value = req.result;
                      if (value === void 0) {
                        value = null;
                      }
                      if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                      }
                      resolve(value);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (cursor) {
                        var value = cursor.value;
                        if (_isEncodedBlob(value)) {
                          value = _decodeBlob(value);
                        }
                        var result = iterator(value, cursor.key, iterationNumber++);
                        if (result !== void 0) {
                          resolve(result);
                        } else {
                          cursor["continue"]();
                        }
                      } else {
                        resolve();
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              var dbInfo;
              self2.ready().then(function() {
                dbInfo = self2._dbInfo;
                if (toString.call(value) === "[object Blob]") {
                  return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                    if (blobSupport) {
                      return value;
                    }
                    return _encodeBlob(value);
                  });
                }
                return value;
              }).then(function(value2) {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    if (value2 === null) {
                      value2 = void 0;
                    }
                    var req = store.put(value2, key2);
                    transaction.oncomplete = function() {
                      if (value2 === void 0) {
                        value2 = null;
                      }
                      resolve(value2);
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store["delete"](key2);
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onerror = function() {
                      reject(req.error);
                    };
                    transaction.onabort = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.clear();
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.count();
                    req.onsuccess = function() {
                      resolve(req.result);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              if (n < 0) {
                resolve(null);
                return;
              }
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(null);
                        return;
                      }
                      if (n === 0) {
                        resolve(cursor.key);
                      } else {
                        if (!advanced) {
                          advanced = true;
                          cursor.advance(n);
                        } else {
                          resolve(cursor.key);
                        }
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys2 = [];
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(keys2);
                        return;
                      }
                      keys2.push(cursor.key);
                      cursor["continue"]();
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
              var dbPromise = isCurrentDb ? Promise$1.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;
                dbContext.db = db;
                for (var i = 0; i < forages.length; i++) {
                  forages[i]._dbInfo.db = db;
                }
                return db;
              });
              if (!options.storeName) {
                promise = dbPromise.then(function(db) {
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                  }
                  var dropDBPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.deleteDatabase(options.name);
                    req.onerror = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      reject(req.error);
                    };
                    req.onblocked = function() {
                      console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      resolve(db2);
                    };
                  });
                  return dropDBPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var i2 = 0; i2 < forages.length; i2++) {
                      var _forage = forages[i2];
                      _advanceReadiness(_forage._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              } else {
                promise = dbPromise.then(function(db) {
                  if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                  }
                  var newVersion = db.version + 1;
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                  }
                  var dropObjectPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.open(options.name, newVersion);
                    req.onerror = function(err) {
                      var db2 = req.result;
                      db2.close();
                      reject(err);
                    };
                    req.onupgradeneeded = function() {
                      var db2 = req.result;
                      db2.deleteObjectStore(options.storeName);
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      db2.close();
                      resolve(db2);
                    };
                  });
                  return dropObjectPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var j = 0; j < forages.length; j++) {
                      var _forage2 = forages[j];
                      _forage2._dbInfo.db = db2;
                      _advanceReadiness(_forage2._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              }
            }
            executeCallback(promise, callback);
            return promise;
          }
          var asyncStorage = {
            _driver: "asyncStorage",
            _initStorage,
            _support: isIndexedDBValid(),
            iterate,
            getItem,
            setItem,
            removeItem,
            clear,
            length,
            key,
            keys,
            dropInstance
          };
          function isWebSQLValid() {
            return typeof openDatabase === "function";
          }
          var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          var BLOB_TYPE_PREFIX = "~~local_forage_type~";
          var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
          var SERIALIZED_MARKER = "__lfsc__:";
          var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
          var TYPE_ARRAYBUFFER = "arbf";
          var TYPE_BLOB = "blob";
          var TYPE_INT8ARRAY = "si08";
          var TYPE_UINT8ARRAY = "ui08";
          var TYPE_UINT8CLAMPEDARRAY = "uic8";
          var TYPE_INT16ARRAY = "si16";
          var TYPE_INT32ARRAY = "si32";
          var TYPE_UINT16ARRAY = "ur16";
          var TYPE_UINT32ARRAY = "ui32";
          var TYPE_FLOAT32ARRAY = "fl32";
          var TYPE_FLOAT64ARRAY = "fl64";
          var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
          var toString$1 = Object.prototype.toString;
          function stringToBuffer(serializedString) {
            var bufferLength = serializedString.length * 0.75;
            var len = serializedString.length;
            var i;
            var p = 0;
            var encoded1, encoded2, encoded3, encoded4;
            if (serializedString[serializedString.length - 1] === "=") {
              bufferLength--;
              if (serializedString[serializedString.length - 2] === "=") {
                bufferLength--;
              }
            }
            var buffer = new ArrayBuffer(bufferLength);
            var bytes = new Uint8Array(buffer);
            for (i = 0; i < len; i += 4) {
              encoded1 = BASE_CHARS.indexOf(serializedString[i]);
              encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
              encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
              encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
              bytes[p++] = encoded1 << 2 | encoded2 >> 4;
              bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
              bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
            }
            return buffer;
          }
          function bufferToString(buffer) {
            var bytes = new Uint8Array(buffer);
            var base64String = "";
            var i;
            for (i = 0; i < bytes.length; i += 3) {
              base64String += BASE_CHARS[bytes[i] >> 2];
              base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
              base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
              base64String += BASE_CHARS[bytes[i + 2] & 63];
            }
            if (bytes.length % 3 === 2) {
              base64String = base64String.substring(0, base64String.length - 1) + "=";
            } else if (bytes.length % 3 === 1) {
              base64String = base64String.substring(0, base64String.length - 2) + "==";
            }
            return base64String;
          }
          function serialize(value, callback) {
            var valueType = "";
            if (value) {
              valueType = toString$1.call(value);
            }
            if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
              var buffer;
              var marker = SERIALIZED_MARKER;
              if (value instanceof ArrayBuffer) {
                buffer = value;
                marker += TYPE_ARRAYBUFFER;
              } else {
                buffer = value.buffer;
                if (valueType === "[object Int8Array]") {
                  marker += TYPE_INT8ARRAY;
                } else if (valueType === "[object Uint8Array]") {
                  marker += TYPE_UINT8ARRAY;
                } else if (valueType === "[object Uint8ClampedArray]") {
                  marker += TYPE_UINT8CLAMPEDARRAY;
                } else if (valueType === "[object Int16Array]") {
                  marker += TYPE_INT16ARRAY;
                } else if (valueType === "[object Uint16Array]") {
                  marker += TYPE_UINT16ARRAY;
                } else if (valueType === "[object Int32Array]") {
                  marker += TYPE_INT32ARRAY;
                } else if (valueType === "[object Uint32Array]") {
                  marker += TYPE_UINT32ARRAY;
                } else if (valueType === "[object Float32Array]") {
                  marker += TYPE_FLOAT32ARRAY;
                } else if (valueType === "[object Float64Array]") {
                  marker += TYPE_FLOAT64ARRAY;
                } else {
                  callback(new Error("Failed to get type for BinaryArray"));
                }
              }
              callback(marker + bufferToString(buffer));
            } else if (valueType === "[object Blob]") {
              var fileReader = new FileReader();
              fileReader.onload = function() {
                var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                callback(SERIALIZED_MARKER + TYPE_BLOB + str);
              };
              fileReader.readAsArrayBuffer(value);
            } else {
              try {
                callback(JSON.stringify(value));
              } catch (e) {
                console.error("Couldn't convert value into a JSON string: ", value);
                callback(null, e);
              }
            }
          }
          function deserialize(value) {
            if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
              return JSON.parse(value);
            }
            var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
            var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
            var blobType;
            if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
              var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
              blobType = matcher[1];
              serializedString = serializedString.substring(matcher[0].length);
            }
            var buffer = stringToBuffer(serializedString);
            switch (type) {
              case TYPE_ARRAYBUFFER:
                return buffer;
              case TYPE_BLOB:
                return createBlob([buffer], { type: blobType });
              case TYPE_INT8ARRAY:
                return new Int8Array(buffer);
              case TYPE_UINT8ARRAY:
                return new Uint8Array(buffer);
              case TYPE_UINT8CLAMPEDARRAY:
                return new Uint8ClampedArray(buffer);
              case TYPE_INT16ARRAY:
                return new Int16Array(buffer);
              case TYPE_UINT16ARRAY:
                return new Uint16Array(buffer);
              case TYPE_INT32ARRAY:
                return new Int32Array(buffer);
              case TYPE_UINT32ARRAY:
                return new Uint32Array(buffer);
              case TYPE_FLOAT32ARRAY:
                return new Float32Array(buffer);
              case TYPE_FLOAT64ARRAY:
                return new Float64Array(buffer);
              default:
                throw new Error("Unkown type: " + type);
            }
          }
          var localforageSerializer = {
            serialize,
            deserialize,
            stringToBuffer,
            bufferToString
          };
          function createDbTable(t, dbInfo, callback, errorCallback) {
            t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
          }
          function _initStorage$1(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
              }
            }
            var dbInfoPromise = new Promise$1(function(resolve, reject) {
              try {
                dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
              } catch (e) {
                return reject(e);
              }
              dbInfo.db.transaction(function(t) {
                createDbTable(t, dbInfo, function() {
                  self2._dbInfo = dbInfo;
                  resolve();
                }, function(t2, error) {
                  reject(error);
                });
              }, reject);
            });
            dbInfo.serializer = localforageSerializer;
            return dbInfoPromise;
          }
          function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
            t.executeSql(sqlStatement, args, callback, function(t2, error) {
              if (error.code === error.SYNTAX_ERR) {
                t2.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t3, results) {
                  if (!results.rows.length) {
                    createDbTable(t3, dbInfo, function() {
                      t3.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                  } else {
                    errorCallback(t3, error);
                  }
                }, errorCallback);
              } else {
                errorCallback(t2, error);
              }
            }, errorCallback);
          }
          function getItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;
                    if (result) {
                      result = dbInfo.serializer.deserialize(result);
                    }
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$1(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t2, results) {
                    var rows = results.rows;
                    var length2 = rows.length;
                    for (var i = 0; i < length2; i++) {
                      var item = rows.item(i);
                      var result = item.value;
                      if (result) {
                        result = dbInfo.serializer.deserialize(result);
                      }
                      result = iterator(result, item.key, i + 1);
                      if (result !== void 0) {
                        resolve(result);
                        return;
                      }
                    }
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function _setItem(key2, value, callback, retriesLeft) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                if (value === void 0) {
                  value = null;
                }
                var originalValue = value;
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    dbInfo.db.transaction(function(t) {
                      tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                        resolve(originalValue);
                      }, function(t2, error2) {
                        reject(error2);
                      });
                    }, function(sqlError) {
                      if (sqlError.code === sqlError.QUOTA_ERR) {
                        if (retriesLeft > 0) {
                          resolve(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                          return;
                        }
                        reject(sqlError);
                      }
                    });
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$1(key2, value, callback) {
            return _setItem.apply(this, [key2, value, callback, 1]);
          }
          function removeItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t2, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$1(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n + 1], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t2, results) {
                    var keys2 = [];
                    for (var i = 0; i < results.rows.length; i++) {
                      keys2.push(results.rows.item(i).key);
                    }
                    resolve(keys2);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getAllStoreNames(db) {
            return new Promise$1(function(resolve, reject) {
              db.transaction(function(t) {
                t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t2, results) {
                  var storeNames = [];
                  for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                  }
                  resolve({
                    db,
                    storeNames
                  });
                }, function(t2, error) {
                  reject(error);
                });
              }, function(sqlError) {
                reject(sqlError);
              });
            });
          }
          function dropInstance$1(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                var db;
                if (options.name === currentConfig.name) {
                  db = self2._dbInfo.db;
                } else {
                  db = openDatabase(options.name, "", "", 0);
                }
                if (!options.storeName) {
                  resolve(getAllStoreNames(db));
                } else {
                  resolve({
                    db,
                    storeNames: [options.storeName]
                  });
                }
              }).then(function(operationInfo) {
                return new Promise$1(function(resolve, reject) {
                  operationInfo.db.transaction(function(t) {
                    function dropTable(storeName) {
                      return new Promise$1(function(resolve2, reject2) {
                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                          resolve2();
                        }, function(t2, error) {
                          reject2(error);
                        });
                      });
                    }
                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                      operations.push(dropTable(operationInfo.storeNames[i]));
                    }
                    Promise$1.all(operations).then(function() {
                      resolve();
                    })["catch"](function(e) {
                      reject(e);
                    });
                  }, function(sqlError) {
                    reject(sqlError);
                  });
                });
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var webSQLStorage = {
            _driver: "webSQLStorage",
            _initStorage: _initStorage$1,
            _support: isWebSQLValid(),
            iterate: iterate$1,
            getItem: getItem$1,
            setItem: setItem$1,
            removeItem: removeItem$1,
            clear: clear$1,
            length: length$1,
            key: key$1,
            keys: keys$1,
            dropInstance: dropInstance$1
          };
          function isLocalStorageValid() {
            try {
              return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
              !!localStorage.setItem;
            } catch (e) {
              return false;
            }
          }
          function _getKeyPrefix(options, defaultConfig) {
            var keyPrefix = options.name + "/";
            if (options.storeName !== defaultConfig.storeName) {
              keyPrefix += options.storeName + "/";
            }
            return keyPrefix;
          }
          function checkIfLocalStorageThrows() {
            var localStorageTestKey = "_localforage_support_test";
            try {
              localStorage.setItem(localStorageTestKey, true);
              localStorage.removeItem(localStorageTestKey);
              return false;
            } catch (e) {
              return true;
            }
          }
          function _isLocalStorageUsable() {
            return !checkIfLocalStorageThrows() || localStorage.length > 0;
          }
          function _initStorage$2(options) {
            var self2 = this;
            var dbInfo = {};
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
            if (!_isLocalStorageUsable()) {
              return Promise$1.reject();
            }
            self2._dbInfo = dbInfo;
            dbInfo.serializer = localforageSerializer;
            return Promise$1.resolve();
          }
          function clear$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var keyPrefix = self2._dbInfo.keyPrefix;
              for (var i = localStorage.length - 1; i >= 0; i--) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) === 0) {
                  localStorage.removeItem(key2);
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result = localStorage.getItem(dbInfo.keyPrefix + key2);
              if (result) {
                result = dbInfo.serializer.deserialize(result);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$2(iterator, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var keyPrefix = dbInfo.keyPrefix;
              var keyPrefixLength = keyPrefix.length;
              var length2 = localStorage.length;
              var iterationNumber = 1;
              for (var i = 0; i < length2; i++) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) !== 0) {
                  continue;
                }
                var value = localStorage.getItem(key2);
                if (value) {
                  value = dbInfo.serializer.deserialize(value);
                }
                value = iterator(value, key2.substring(keyPrefixLength), iterationNumber++);
                if (value !== void 0) {
                  return value;
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$2(n, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result;
              try {
                result = localStorage.key(n);
              } catch (error) {
                result = null;
              }
              if (result) {
                result = result.substring(dbInfo.keyPrefix.length);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var length2 = localStorage.length;
              var keys2 = [];
              for (var i = 0; i < length2; i++) {
                var itemKey = localStorage.key(i);
                if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                  keys2.push(itemKey.substring(dbInfo.keyPrefix.length));
                }
              }
              return keys2;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$2(callback) {
            var self2 = this;
            var promise = self2.keys().then(function(keys2) {
              return keys2.length;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              localStorage.removeItem(dbInfo.keyPrefix + key2);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$2(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              if (value === void 0) {
                value = null;
              }
              var originalValue = value;
              return new Promise$1(function(resolve, reject) {
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    try {
                      localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                      resolve(originalValue);
                    } catch (e) {
                      if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                        reject(e);
                      }
                      reject(e);
                    }
                  }
                });
              });
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance$2(options, callback) {
            callback = getCallback.apply(this, arguments);
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              var currentConfig = this.config();
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                if (!options.storeName) {
                  resolve(options.name + "/");
                } else {
                  resolve(_getKeyPrefix(options, self2._defaultConfig));
                }
              }).then(function(keyPrefix) {
                for (var i = localStorage.length - 1; i >= 0; i--) {
                  var key2 = localStorage.key(i);
                  if (key2.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key2);
                  }
                }
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var localStorageWrapper = {
            _driver: "localStorageWrapper",
            _initStorage: _initStorage$2,
            _support: isLocalStorageValid(),
            iterate: iterate$2,
            getItem: getItem$2,
            setItem: setItem$2,
            removeItem: removeItem$2,
            clear: clear$2,
            length: length$2,
            key: key$2,
            keys: keys$2,
            dropInstance: dropInstance$2
          };
          var sameValue = function sameValue2(x, y) {
            return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
          };
          var includes = function includes2(array, searchElement) {
            var len = array.length;
            var i = 0;
            while (i < len) {
              if (sameValue(array[i], searchElement)) {
                return true;
              }
              i++;
            }
            return false;
          };
          var isArray = Array.isArray || function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
          };
          var DefinedDrivers = {};
          var DriverSupport = {};
          var DefaultDrivers = {
            INDEXEDDB: asyncStorage,
            WEBSQL: webSQLStorage,
            LOCALSTORAGE: localStorageWrapper
          };
          var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
          var OptionalDriverMethods = ["dropInstance"];
          var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
          var DefaultConfig = {
            description: "",
            driver: DefaultDriverOrder.slice(),
            name: "localforage",
            // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
            // we can use without a prompt.
            size: 4980736,
            storeName: "keyvaluepairs",
            version: 1
          };
          function callWhenReady(localForageInstance, libraryMethod) {
            localForageInstance[libraryMethod] = function() {
              var _args = arguments;
              return localForageInstance.ready().then(function() {
                return localForageInstance[libraryMethod].apply(localForageInstance, _args);
              });
            };
          }
          function extend() {
            for (var i = 1; i < arguments.length; i++) {
              var arg = arguments[i];
              if (arg) {
                for (var _key in arg) {
                  if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                      arguments[0][_key] = arg[_key].slice();
                    } else {
                      arguments[0][_key] = arg[_key];
                    }
                  }
                }
              }
            }
            return arguments[0];
          }
          var LocalForage = function() {
            function LocalForage2(options) {
              _classCallCheck(this, LocalForage2);
              for (var driverTypeKey in DefaultDrivers) {
                if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                  var driver = DefaultDrivers[driverTypeKey];
                  var driverName = driver._driver;
                  this[driverTypeKey] = driverName;
                  if (!DefinedDrivers[driverName]) {
                    this.defineDriver(driver);
                  }
                }
              }
              this._defaultConfig = extend({}, DefaultConfig);
              this._config = extend({}, this._defaultConfig, options);
              this._driverSet = null;
              this._initDriver = null;
              this._ready = false;
              this._dbInfo = null;
              this._wrapLibraryMethodsWithReady();
              this.setDriver(this._config.driver)["catch"](function() {
              });
            }
            LocalForage2.prototype.config = function config(options) {
              if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                if (this._ready) {
                  return new Error("Can't call config() after localforage has been used.");
                }
                for (var i in options) {
                  if (i === "storeName") {
                    options[i] = options[i].replace(/\W/g, "_");
                  }
                  if (i === "version" && typeof options[i] !== "number") {
                    return new Error("Database version must be a number.");
                  }
                  this._config[i] = options[i];
                }
                if ("driver" in options && options.driver) {
                  return this.setDriver(this._config.driver);
                }
                return true;
              } else if (typeof options === "string") {
                return this._config[options];
              } else {
                return this._config;
              }
            };
            LocalForage2.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
              var promise = new Promise$1(function(resolve, reject) {
                try {
                  var driverName = driverObject._driver;
                  var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                  if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                  }
                  var driverMethods = LibraryMethods.concat("_initStorage");
                  for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                      reject(complianceError);
                      return;
                    }
                  }
                  var configureMissingMethods = function configureMissingMethods2() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                      return function() {
                        var error = new Error("Method " + methodName + " is not implemented by the current driver");
                        var promise2 = Promise$1.reject(error);
                        executeCallback(promise2, arguments[arguments.length - 1]);
                        return promise2;
                      };
                    };
                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                      var optionalDriverMethod = OptionalDriverMethods[_i];
                      if (!driverObject[optionalDriverMethod]) {
                        driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                      }
                    }
                  };
                  configureMissingMethods();
                  var setDriverSupport = function setDriverSupport2(support) {
                    if (DefinedDrivers[driverName]) {
                      console.info("Redefining LocalForage driver: " + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    resolve();
                  };
                  if ("_support" in driverObject) {
                    if (driverObject._support && typeof driverObject._support === "function") {
                      driverObject._support().then(setDriverSupport, reject);
                    } else {
                      setDriverSupport(!!driverObject._support);
                    }
                  } else {
                    setDriverSupport(true);
                  }
                } catch (e) {
                  reject(e);
                }
              });
              executeTwoCallbacks(promise, callback, errorCallback);
              return promise;
            };
            LocalForage2.prototype.driver = function driver() {
              return this._driver || null;
            };
            LocalForage2.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
              var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
              executeTwoCallbacks(getDriverPromise, callback, errorCallback);
              return getDriverPromise;
            };
            LocalForage2.prototype.getSerializer = function getSerializer(callback) {
              var serializerPromise = Promise$1.resolve(localforageSerializer);
              executeTwoCallbacks(serializerPromise, callback);
              return serializerPromise;
            };
            LocalForage2.prototype.ready = function ready(callback) {
              var self2 = this;
              var promise = self2._driverSet.then(function() {
                if (self2._ready === null) {
                  self2._ready = self2._initDriver();
                }
                return self2._ready;
              });
              executeTwoCallbacks(promise, callback, callback);
              return promise;
            };
            LocalForage2.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
              var self2 = this;
              if (!isArray(drivers)) {
                drivers = [drivers];
              }
              var supportedDrivers = this._getSupportedDrivers(drivers);
              function setDriverToConfig() {
                self2._config.driver = self2.driver();
              }
              function extendSelfWithDriver(driver) {
                self2._extend(driver);
                setDriverToConfig();
                self2._ready = self2._initStorage(self2._config);
                return self2._ready;
              }
              function initDriver(supportedDrivers2) {
                return function() {
                  var currentDriverIndex = 0;
                  function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers2.length) {
                      var driverName = supportedDrivers2[currentDriverIndex];
                      currentDriverIndex++;
                      self2._dbInfo = null;
                      self2._ready = null;
                      return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }
                    setDriverToConfig();
                    var error = new Error("No available storage method found.");
                    self2._driverSet = Promise$1.reject(error);
                    return self2._driverSet;
                  }
                  return driverPromiseLoop();
                };
              }
              var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                return Promise$1.resolve();
              }) : Promise$1.resolve();
              this._driverSet = oldDriverSetDone.then(function() {
                var driverName = supportedDrivers[0];
                self2._dbInfo = null;
                self2._ready = null;
                return self2.getDriver(driverName).then(function(driver) {
                  self2._driver = driver._driver;
                  setDriverToConfig();
                  self2._wrapLibraryMethodsWithReady();
                  self2._initDriver = initDriver(supportedDrivers);
                });
              })["catch"](function() {
                setDriverToConfig();
                var error = new Error("No available storage method found.");
                self2._driverSet = Promise$1.reject(error);
                return self2._driverSet;
              });
              executeTwoCallbacks(this._driverSet, callback, errorCallback);
              return this._driverSet;
            };
            LocalForage2.prototype.supports = function supports(driverName) {
              return !!DriverSupport[driverName];
            };
            LocalForage2.prototype._extend = function _extend(libraryMethodsAndProperties) {
              extend(this, libraryMethodsAndProperties);
            };
            LocalForage2.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
              var supportedDrivers = [];
              for (var i = 0, len = drivers.length; i < len; i++) {
                var driverName = drivers[i];
                if (this.supports(driverName)) {
                  supportedDrivers.push(driverName);
                }
              }
              return supportedDrivers;
            };
            LocalForage2.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
              for (var i = 0, len = LibraryMethods.length; i < len; i++) {
                callWhenReady(this, LibraryMethods[i]);
              }
            };
            LocalForage2.prototype.createInstance = function createInstance(options) {
              return new LocalForage2(options);
            };
            return LocalForage2;
          }();
          var localforage_js = new LocalForage();
          module3.exports = localforage_js;
        }, { "3": 3 }] }, {}, [4])(4);
      });
    }
  });

  // app/scripts/common/function/addEvent.js
  function addEvent(evt, selector, handler) {
    evt.split(" ").forEach((event) => {
      document.addEventListener(event, function(event2) {
        if (event2.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event2.target.closest(selector), arguments);
        }
      }, false);
    });
  }

  // app/scripts/common/function/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/common/function/serializeForm.js
  function serializeForm(form) {
    const obj = {};
    const formData = new FormData(form);
    let properties = {};
    let hasProperties = false;
    for (const key of formData.keys()) {
      if (key.includes("properties")) {
        if (formData.get(key).length) {
          let newKey = key.slice(0, key.length - 1);
          newKey = newKey.replace("properties[", "");
          properties = Object.assign(properties, {
            [newKey]: formData.get(key)
          });
          hasProperties = true;
        }
      } else {
        obj[key] = formData.get(key);
      }
    }
    if (hasProperties)
      obj.properties = properties;
    return JSON.stringify(obj);
  }

  // app/scripts/common/function/storage.js
  var import_localforage = __toESM(require_localforage(), 1);
  function storage(storageKey) {
    const key = storageKey;
    const storage2 = {
      get: async () => {
        const data = await import_localforage.default.getItem(key);
        if (!data) {
          return data;
        }
        const { expire, value } = data;
        if (expire < Date.now()) {
          import_localforage.default.removeItem(key);
          return null;
        }
        return value;
      },
      set: (value, expire = false) => {
        if (expire) {
          const dataExpired = (/* @__PURE__ */ new Date()).getTime() + 24 * 60 * 60 * expire;
          return import_localforage.default.setItem(key, { value, expire: dataExpired });
        }
        return import_localforage.default.setItem(key, { value });
      }
    };
    return storage2;
  }
  function localStorage2(storageKey, defaultValue = []) {
    const key = storageKey;
    const storage2 = {
      get: () => {
        const data = window.localStorage.getItem(key);
        if (data) {
          return data.split(",");
        }
        return defaultValue;
      },
      set: (value, expire = false) => {
        if (expire) {
          const dataExpired = (/* @__PURE__ */ new Date()).getTime() + 24 * 60 * 60 * expire;
          return window.localStorage.setItem(key, { value, expire: dataExpired });
        }
        storage2.dispatchEvent();
        console.log("in set", value);
        return window.localStorage.setItem(key, value);
      },
      clear: () => {
        window.localStorage.removeItem(key);
        storage2.dispatchEvent();
      },
      dispatchEvent: () => {
        window.dispatchEvent(new CustomEvent(`localStorage:${key}:change`, {
          bubbles: true,
          detail: {}
        }));
      }
    };
    return storage2;
  }
  function sessionStorage(storageKey) {
    const key = storageKey;
    const sessionStore = window.sessionStorage;
    const storage2 = {
      get: () => {
        const data = sessionStore.getItem(key) || null;
        return data;
      },
      set: (value) => {
        return sessionStore.setItem(key, value);
      },
      clearAll: () => {
        sessionStore.removeItem(key);
      }
    };
    return storage2;
  }

  // app/scripts/common/index.js
  window.theme = Object.assign(window.theme || {}, {
    addEvent,
    serializeForm,
    debounceTime,
    localStorage: localStorage2,
    sessionStorage,
    toggleSticky: function(hide = true) {
      if (hide) {
        document.querySelector("sticky-header")?.classList.add("tnone");
        return;
      }
      document.querySelector("sticky-header")?.classList.remove("tnone");
    },
    inViewPort(el, callback, once = null) {
      const observer = new IntersectionObserver((entries, observer2) => {
        callback(entries[0].isIntersecting);
        if (entries[0].isIntersecting) {
          once && observer2.disconnect();
        }
      });
      observer.observe(el);
    }
  });

  // app/scripts/common/events/calculateScrollBarWidth.js
  function scrollBarWidth() {
    let t = document.body.getBoundingClientRect();
    if (t.left + t.right < window.innerWidth)
      return window.innerWidth - (t.left + t.right);
    return 0;
  }
  document.documentElement.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  window.addEventListener("resize", () => {
    document.documentElement.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  });

  // app/scripts/common/events/toggleClass.js
  var { addEvent: addEvent2 } = theme;
  theme.prepareMobileNavigation = (popup) => {
    popup.querySelectorAll(".sub-layer:not(.active)").forEach(panel => { panel.inert = true; panel.setAttribute("aria-hidden", "true"); });
    popup.querySelectorAll(".jsToggleClass[data-target]").forEach((button) => {
      if (button.dataset.classRule === "remove") return;
      if (!button.dataset.target.startsWith("#mobile")) return;
      let panel = popup.querySelector(button.dataset.target);
      if (!panel && button.dataset.fallbackTarget) panel = popup.querySelector(button.dataset.fallbackTarget);
      button.hidden = !panel;
      if (panel) {
        button.dataset.target = `#${panel.id}`;
        button.setAttribute("aria-controls", panel.id);
        button.setAttribute("aria-expanded", String(panel.classList.contains("active")));
      }
    });
    if (!popup.dataset.mobileNavigationReady) {
      popup.dataset.mobileNavigationReady = "true";
      popup.addEventListener("keydown", (event) => {
        if (event.key !== "Escape" || event.defaultPrevented || event.target.closest("details[open]")) return;
        const activeLayer = event.target.closest(".sub-layer.active") || popup.querySelector(".sub-layer.active");
        const backButton = activeLayer?.querySelector(".btn-back");
        if (!backButton) return;
        event.preventDefault();
        event.stopPropagation();
        backButton.click();
      }, true);
      if (popup.matches("[data-esp-mobile-menu]")) {
        const revealFocusedControl = () => {
          cancelAnimationFrame(popup.mobileNavigationFocusFrame);
          const target = document.activeElement;
          popup.mobileNavigationFocusFrame = requestAnimationFrame(() => {
            if (!popup.isConnected || popup.getAttribute("aria-hidden") !== "false" || !target?.isConnected || document.activeElement !== target || !popup.contains(target)) return;
            const layer = target.closest(".main-layer, .sub-layer");
            const content = popup.querySelector(":scope > .popup__content");
            const frame = content?.querySelector(":scope > .popup__body");
            if (!layer || !frame || !popup.contains(layer) || layer.matches(".sub-layer:not(.active)") || target.closest('[hidden],[inert],[aria-hidden="true"]') || !target.getClientRects().length || getComputedStyle(target).visibility === "hidden") return;
            for (let ancestor = target.parentElement; ancestor && ancestor !== popup; ancestor = ancestor.parentElement) {
              if (ancestor.tagName === "DETAILS" && !ancestor.open && !ancestor.querySelector(":scope > summary")?.contains(target)) return;
            }
            const verticalDelta = (containers) => {
              const rectangles = containers.map((container) => container.getBoundingClientRect());
              let top = Math.max(0, ...rectangles.map((rect) => rect.top));
              let bottom = Math.min(window.innerHeight, ...rectangles.map((rect) => rect.bottom));
              if (bottom <= top) return 0;
              const rect = target.getBoundingClientRect();
              // Leave room for the existing focus ring when the control fits.
              if (bottom - top >= rect.height + 8) { top += 4; bottom -= 4; }
              if (rect.top < top || rect.height > bottom - top) return rect.top - top;
              if (rect.bottom > bottom) return rect.bottom - bottom;
              return 0;
            };
            const containers = [layer, frame, content, popup];
            if (!verticalDelta(containers)) return;
            target.scrollIntoView?.({ behavior: "instant", block: "nearest", inline: "nearest" });
            // Large page-level scroll margins can leave a partly visible item
            // unchanged with nearest alignment. Correct only actual remaining
            // vertical clipping, without changing focus or horizontal offsets.
            const remaining = verticalDelta(containers);
            if (remaining) layer.scrollTop += remaining;
            const outerRemaining = verticalDelta([content, popup]);
            if (outerRemaining) content.scrollTop += outerRemaining;
          });
        };
        popup.addEventListener("focusin", revealFocusedControl);
        popup.mobileNavigationResizeObserver = new ResizeObserver(revealFocusedControl);
      }
    }
    popup.mobileNavigationResizeObserver?.observe(popup);
    const mobileFrame = popup.querySelector(":scope > .popup__content > .popup__body");
    if (mobileFrame) popup.mobileNavigationResizeObserver?.observe(mobileFrame);
  };
  addEvent2("click", ".jsToggleClass", (e) => {
    const el = e.target.closest(".jsToggleClass");
    const target = document.querySelectorAll(el.dataset.target || null);
    if (!target.length)
      return;
    let { className, classRemove, classRule, classEvent } = el.dataset;
    if (!className) {
      className = "active";
    }
    if (classEvent == "none") {
      e.preventDefault();
      e.stopPropagation();
    }
    target.forEach((i) => {
      switch (classRule) {
        case "add":
          i.classList.add(...className.split(","));
          break;
        case "remove":
          i.classList.remove(...className.split(","));
          break;
        default:
          className.split(",").forEach((c) => i.classList.toggle(c));
          break;
      }
      if (classRemove) {
        i.classList.remove(...classRemove.split(","));
      }
      if (i.matches(".mobile-navigation-layer.sub-layer")) {
        const popup = i.closest("popup-component");
        const open = i.classList.contains("active");
        const mainLayer = popup?.querySelector(".main-layer");
        if (open) i.returnFocus = el;
        i.inert = !open;
        i.setAttribute("aria-hidden", String(!open));
        popup?.querySelectorAll(".jsToggleClass[data-target]").forEach((control) => {
          if (control.dataset.target === `#${i.id}` && control.dataset.classRule !== "remove") control.setAttribute("aria-expanded", String(open));
        });
        if (open) {
          const focusAttempt = {};
          const focusStarted = performance.now();
          i.mobileFocusAttempt = focusAttempt;
          const focusLayer = () => {
            if (i.mobileFocusAttempt !== focusAttempt || !i.isConnected || !i.classList.contains("active") || popup?.getAttribute("aria-hidden") === "true") return;
            const focusTarget = i.querySelector(".btn-back, button, a[href], summary") || i;
            if (focusTarget === i) i.setAttribute("tabindex", "-1");
            focusTarget.focus({ preventScroll: true });
            if (!i.contains(document.activeElement)) {
              // A newly revealed panel may still be hidden while its first CSS transition starts.
              if (performance.now() - focusStarted < 750) {
                requestAnimationFrame(focusLayer);
                return;
              }
              i.setAttribute("tabindex", "-1");
              i.focus({ preventScroll: true });
            }
            if (i.contains(document.activeElement) && mainLayer) {
              mainLayer.inert = true;
              mainLayer.setAttribute("aria-hidden", "true");
            }
          };
          focusLayer();
        } else {
          i.mobileFocusAttempt = null;
          if (mainLayer) { mainLayer.inert = false; mainLayer.removeAttribute("aria-hidden"); }
          i.returnFocus?.focus();
        }
      }
      if (i === document.body && className === "show-header-search") {
        const open = i.classList.contains("show-header-search");
        el.setAttribute("aria-expanded", String(open));
        const search = document.querySelector("header .header-search");
        if (search) {
          if (!search.id) search.id = "header-search-panel";
          el.setAttribute("aria-controls", search.id);
          if (open) search.querySelector("input[name=q]")?.focus();
        }
      }
      i.className.includes("header-search") && document.querySelector("header predictive-search")?.focusSearch();
    });
  });

  // app/scripts/common/events/togglePopup.js
  var { addEvent: addEvent3, loadTemplate } = theme;
  addEvent3("click", ".js-popup-toggle", (e) => {
    const el = e.target.closest(".js-popup-toggle");
    const popup = document.querySelector(el.dataset.control);
    console.log("el", el.dataset.control);
    if (!popup)
      return;
    popup.tagName.toLowerCase().includes("popup") && popup.toggle((resp) => {
      el.classList.toggle("active", resp?.isActive);
    });
  });
  addEvent3("click", ".js-popup-close", (e) => {
    e.preventDefault();
    const el = e.target;
    const bodyClass = ["popup-show", "overflow-hidden"];
    const popup = el.closest(".js-popup");
    if (!popup)
      return;
    popup.classList.remove("active");
    popup.setAttribute("aria-hidden", !popup.classList.contains("active"));
    document.body.classList.remove(...bodyClass);
    document.querySelectorAll(`.js-popup-toggle[data-control="${popup.dataset.control}"]`)?.forEach((el2) => el2.classList.remove("active"));
  });

  // app/scripts/common/events/loadTemplate.js
  var { addEvent: addEvent4 } = theme;
  addEvent4("click", ".jsTemplate", (e) => {
    console.log("e", e.target);
    const node = e.target.closest(".jsTemplate");
    const template = document.querySelector(node.dataset.template);
    e.preventDefault();
    e.stopPropagation();
    template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
      template.insertAdjacentElement("beforebegin", child);
    });
    if (template.tagName == "NOSCRIPT") {
      const div = document.createElement("div");
      div.innerHTML = template.innerHTML;
      template.insertAdjacentElement("beforebegin", div);
    }
    template.remove();
    node.classList.remove("jsTemplate");
    node.removeAttribute("data-template");
    setTimeout(() => {
      node.click();
    }, 300);
  });

  // app/scripts/common/events/keyEvents.js
  document.addEventListener("keyup", (e) => {
    e.key == `Escape` && document.querySelectorAll("details[open]")?.forEach((item) => item.removeAttribute("open"));
  });

  // app/scripts/common/function/cart.js
  window.cartForm = class extends HTMLElement {
    constructor() {
      super();
      this.sectionName = this.dataset.section || "cart-section";
      this.sections = [
        {
          key: "count",
          section: "cart-live-region-text"
        },
        {
          key: "noti",
          section: "cart-noti"
        },
        {
          key: "section",
          section: this.sectionName
        }
      ];
      window.addEventListener("cart:refresh", this.cartRefresh.bind(this));
      this.addEventListener("click", (event) => {
        if ((this.isUpdating || this.cartNeedsRefresh) && event.target.closest('quantity-input button, cart-remove-button a, [name="checkout"]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      this.addEventListener("keydown", (event) => {
        if (event.key === "Enter" && event.target.matches('input[name="updates[]"]')) {
          event.preventDefault();
          this.onChange(event);
        }
      });
      this.addEventListener("submit", (event) => {
        if (this.isUpdating || this.cartNeedsRefresh)
          event.preventDefault();
      });
    }
    getHeader(formData) {
      if (!(formData instanceof FormData)) {
        return { "Content-Type": "application/json;" };
      } else
        return { "X-Requested-With": "XMLHttpRequest" };
    }
    sectionList(section) {
      if (section) {
        const callSection = section.split(",");
        return this.sections.filter((i) => callSection.includes(i.key)).map((i) => i.section).join(",");
      }
      return this.sections.map((i) => i.section).join(",");
    }
    async cartAdd(formData) {
      if (this.isAdding)
        return;
      this.isAdding = true;
      this.clearCartAddError();
      const message = (key, fallback) => window.espAccessibilityStrings?.[key] || fallback;
      const uncertain = message("cartAddUncertain", "We could not confirm whether this item was added. Check your cart before trying again.");
      const loading = document.querySelector("#svg_loading");
      const buttons = this.getSubmitButton.map((button) => ({
        button, nodes: Array.from(button.childNodes), busy: button.getAttribute("aria-busy"),
        label: button.getAttribute("aria-label"), wasDisabled: button.classList.contains("disabled")
      }));
      let added = false;
      try {
        buttons.forEach(({ button }) => {
          const labelled = (button.getAttribute("aria-labelledby") || "").split(/\s+/).map((id) => document.getElementById(id)?.textContent.trim()).filter(Boolean).join(" ");
          const name = labelled || button.getAttribute("aria-label") || button.textContent.trim() || button.value;
          if (name)
            button.setAttribute("aria-label", name);
          button.setAttribute("aria-busy", "true");
          button.classList.add("disabled");
          if (loading && button.tagName === "BUTTON")
            button.replaceChildren(...Array.from(loading.childNodes, (node) => node.cloneNode(true)));
        });
        const result = await fetch(`${theme.routes.cartUrl}/add.js`, {
          method: "POST",
          headers: this.getHeader(formData),
          body: formData
        });
        const response = await result.json();
        if (!response || typeof response !== "object" || Array.isArray(response))
          throw new Error("Cart add response unavailable");
        this.currentState = "add";
        if (!result.ok || response.status) {
          const status = Number(response.status || result.status);
          if (!Number.isInteger(status) || status < 400 || status >= 500)
            throw new Error("Cart add outcome uncertain");
          const explanation = [response.description, response.message].find((value) => typeof value === "string" && value.trim());
          const error = explanation || message("cartAddError", "This item could not be added to your cart as requested.");
          this.showCartAddError(error);
          try {
            await this.cartRefresh({ isSuccess: false, sections: response.sections || [] });
          } catch (refreshError) {
            this.showCartAddError(`${error} ${uncertain}`);
          }
          return;
        }
        const items = Array.isArray(response.items) ? response.items : [response];
        if (!items.length || !items.every((item) => item && Number.isSafeInteger(Number(item.id || item.variant_id)) && Number(item.id || item.variant_id) > 0 && Number.isInteger(Number(item.quantity)) && Number(item.quantity) > 0))
          throw new Error("Cart add response incomplete");
        added = true;
        await this.cartRefresh({ isSuccess: true, sections: response.sections });
      } catch (error) {
        this.showCartAddError(added ? message("cartAddRefreshError", "The item was added, but the cart could not be updated on this page. Check your cart before adding more.") : uncertain);
      } finally {
        buttons.forEach(({ button, nodes, busy, label, wasDisabled }) => {
          if (loading && button.tagName === "BUTTON")
            button.replaceChildren(...nodes);
          if (busy === null) button.removeAttribute("aria-busy");
          else button.setAttribute("aria-busy", busy);
          if (label === null) button.removeAttribute("aria-label");
          else button.setAttribute("aria-label", label);
          button.classList.toggle("disabled", wasDisabled);
        });
        this.isAdding = false;
      }
    }
    clearCartAddError() {
      const error = this.querySelector("[data-cart-add-error]");
      if (!error)
        return;
      error.hidden = true;
      error.querySelector("[data-cart-add-message]").textContent = "";
      this.getSubmitButton.forEach((button) => {
        const ids = (button.getAttribute("aria-describedby") || "").split(/\s+/).filter((id) => id && id !== error.id);
        if (ids.length) button.setAttribute("aria-describedby", ids.join(" "));
        else button.removeAttribute("aria-describedby");
      });
    }
    showCartAddError(message) {
      let error = this.querySelector("[data-cart-add-error]");
      if (!error) {
        error = document.createElement("div");
        let index = 1;
        do { error.id = `CartAddError-${index++}`; } while (document.getElementById(error.id));
        error.className = "jsCartError";
        error.setAttribute("data-cart-add-error", "");
        error.setAttribute("role", "alert");
        error.setAttribute("aria-atomic", "true");
        const text = document.createElement("span");
        text.setAttribute("data-cart-add-message", "");
        const link = document.createElement("a");
        link.href = theme.routes.cartUrl;
        link.textContent = window.espAccessibilityStrings?.cartView || "View Cart";
        error.append(text, document.createTextNode(" "), link);
        this.append(error);
      }
      error.hidden = false;
      error.querySelector("[data-cart-add-message]").textContent = message;
      this.getSubmitButton.forEach((button) => {
        const ids = new Set((button.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
        ids.add(error.id);
        button.setAttribute("aria-describedby", Array.from(ids).join(" "));
      });
    }
    async cartChange(formData) {
      try {
        const result = await fetch(`${theme.routes.cartUrl}/change.js`, {
          method: "POST",
          headers: this.getHeader(formData),
          body: JSON.stringify(formData)
        });
        const response = await result.json();
        this.currentState = "change";
        if (!result.ok || response.status) {
          const message = response.description || response.message || this.dataset.updateError;
          await this.cartRefresh({ isSuccess: false, sections: [] });
          this.showCartError(message, true);
          return;
        }
        await this.cartRefresh({ isSuccess: true, sections: response.sections });
      } catch (error) {
        try {
          await this.cartRefresh({ isSuccess: false, sections: [] });
          this.showCartError(this.dataset.updateError);
        } catch (refreshError) {
          this.showCartError(this.dataset.updateError, false, true);
        }
      } finally {
        this.setCartBusy(false);
        this.changeContext = null;
      }
    }
    async cartUpdate(formData) {
      let response = await fetch(`${theme.routes.cartUrl}/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        },
        body: JSON.stringify({ attributes: formData })
      });
      response = await response.json();
      this.currentState = "update";
      this.onFinished();
    }
    async cartRefresh(response = {}) {
      response = response.detail || response;
      let sections = response.sections;
      if (!sections || !sections[this.sectionList("count")] || !sections[this.sectionName]) {
        const result = await fetch(`${theme.routes.cartUrl}?sections=${this.sectionList()}`);
        if (!result.ok)
          throw new Error("Cart sections unavailable");
        sections = await result.json();
      }
      if (!sections[this.sectionList("count")] || !sections[this.sectionName])
        throw new Error("Cart sections incomplete");
      if (this.currentState === "add" && response.isSuccess)
        this.validateCartAddSections?.(sections);
      const countSection = document.createElement("div");
      countSection.innerHTML = sections[this.sectionList("count")];
      const count = countSection.querySelector("[data-cart-count]")?.dataset.cartCount ?? sections[this.sectionList("count")].split("<!-- split -->")[1];
      this.updateCartCount = count;
      this.cartSummary = countSection.querySelector("[data-cart-summary]")?.textContent.trim() || "";
      const title = countSection.querySelector("[data-cart-title]")?.textContent.trim();
      if (title)
        document.querySelectorAll("[data-cart-title]").forEach((heading) => heading.textContent = title);
      if (this.currentState === "add" && response.isSuccess)
        this.successNotify = sections;
      response.sections = sections;
      this.onUpdating(response);
    }
    onChange(event) {
      const target = event.detail?.customElement?.target || event.target;
      const quantity = event.detail?.customElement ? 0 : Number(target.value);
      let { key, sections: targetSection, sections_url } = target.dataset;
      if (!key || this.isUpdating || this.cartNeedsRefresh)
        return;
      this.clearCartError();
      if (!Number.isInteger(quantity) || quantity < 0 || (!event.detail?.customElement && (!target.value.trim() || !target.checkValidity()))) {
        this.changeContext = { focus: this.cartFocus(target) };
        this.showCartError(target.validationMessage || this.dataset.quantityError, true);
        target.focus();
        this.changeContext = null;
        return;
      }
      let sections = this.sections.map((i) => i.section);
      if (targetSection)
        sections.push(targetSection);
      sections = Array.from(new Set(sections));
      this.currentline = target.closest(".jsLineItem");
      const active = document.activeElement;
      this.changeContext = {
        focus: this.cartFocus(this.contains(active) ? active : target),
        line: this.cartFocus(target),
        product: this.currentline?.querySelector(".product-title")?.textContent.trim() || "",
        removed: quantity === 0,
        focusWasInside: this.contains(active)
      };
      this.body = {
        id: key,
        quantity,
        sections,
        sections_url
      };
      this.setCartBusy(true);
      const status = this.querySelector(".jsCartStatus");
      if (status)
        status.textContent = this.dataset.updating || "";
      return this.cartChange(this.body);
    }
    onUpdating(response) {
      const section = response.sections[this.sectionName];
      if (section) {
        const div = document.createElement("div");
        div.innerHTML = section;
        const replacement = div.querySelector(this.tagName);
        if (!replacement)
          throw new Error("Cart section content unavailable");
        const active = document.activeElement;
        const restore = this.contains(active) || (active === document.body && this.changeContext?.focusWasInside);
        const focus = this.contains(active) ? this.cartFocus(active) : this.changeContext?.focus;
        const openDetails = Array.from(this.querySelectorAll("details"), (details) => details.open);
        this.renderCartContent(replacement);
        this.querySelectorAll("details").forEach((details, index) => {
          if (openDetails[index] !== undefined)
            details.open = openDetails[index];
        });
        this.setCartBusy(false);
        if (restore)
          this.restoreCartFocus(focus, response.isSuccess && this.changeContext?.removed);
        if (response.isSuccess) {
          const status = this.querySelector(".jsCartStatus");
          if (status) {
            status.textContent = this.changeContext?.removed ? (this.dataset.removed || "").replace("[product]", this.changeContext.product).replace("[summary]", this.cartSummary) : this.cartSummary;
          }
        }
      }
      this.onFinished();
    }
    renderCartContent(replacement) {
      const feedback = this.querySelector(".jsCartFeedback");
      const note = this.querySelector("cart-note");
      if (note && replacement.querySelector("cart-note"))
        replacement.querySelector("cart-note").replaceWith(note);
      if (feedback)
        replacement.querySelector(".jsCartFeedback")?.remove();
      Array.from(this.childNodes).forEach((node) => {
        if (node !== feedback)
          node.remove();
      });
      this.append(...Array.from(replacement.childNodes));
    }
    cartFocus(element) {
      if (!element)
        return null;
      const line = element.closest(".jsLineItem");
      return {
        key: line?.dataset.key,
        identity: line?.dataset.cartIdentity,
        index: Array.from(this.querySelectorAll(".jsLineItem")).indexOf(line),
        control: element.dataset.cartControl,
        id: element.id,
        name: element.getAttribute("name")
      };
    }
    restoreCartFocus(focus, removed = false) {
      if (!focus)
        return;
      const lines = Array.from(this.querySelectorAll(".jsLineItem"));
      const matchingLine = lines.find((line) => line.dataset.key === focus.key) || lines.find((line) => focus.identity && line.dataset.cartIdentity === focus.identity);
      const line = matchingLine || lines[Math.min(Math.max(focus.index, 0), lines.length - 1)];
      let target;
      if (removed && !matchingLine) {
        target = line?.querySelector('[data-cart-control="remove"]') || this.querySelector("[data-cart-empty]");
      } else if (focus.key) {
        target = Array.from(line?.querySelectorAll("[data-cart-control]") || []).find((element) => element.dataset.cartControl === focus.control);
        if (!target || target.disabled)
          target = line?.querySelector('input[name="updates[]"]');
      } else {
        target = Array.from(this.querySelectorAll("[id], [data-cart-control], [name]")).find((element) => focus.id ? element.id === focus.id : focus.control ? element.dataset.cartControl === focus.control : focus.name && element.getAttribute("name") === focus.name);
      }
      target?.focus({ preventScroll: true });
    }
    setCartBusy(value) {
      this.isUpdating = value;
      this.setAttribute("aria-busy", String(value));
      const disabled = value || this.cartNeedsRefresh;
      this.querySelectorAll('input[name="updates[]"]').forEach((input) => input.readOnly = Boolean(disabled));
      this.querySelectorAll('quantity-input button, cart-remove-button a, [name="checkout"]').forEach((control) => {
        if (disabled)
          control.setAttribute("aria-disabled", "true");
        else
          control.removeAttribute("aria-disabled");
      });
    }
    clearCartError() {
      const error = this.querySelector(".jsCartError");
      if (error) {
        error.hidden = true;
        error.querySelector(".jsCartErrorMessage").textContent = "";
        error.querySelector(".jsCartRetry").hidden = true;
      }
      this.querySelectorAll('[aria-invalid="true"]').forEach((input) => {
        input.removeAttribute("aria-invalid");
        const descriptions = (input.getAttribute("aria-describedby") || "").split(/\s+/).filter((id) => id && id !== error?.id);
        if (descriptions.length)
          input.setAttribute("aria-describedby", descriptions.join(" "));
        else
          input.removeAttribute("aria-describedby");
      });
    }
    showCartError(message, invalid = false, retry = false) {
      this.cartNeedsRefresh = retry;
      this.setCartBusy(false);
      const error = this.querySelector(".jsCartError");
      if (!error)
        return;
      error.hidden = false;
      error.querySelector(".jsCartErrorMessage").textContent = message || this.dataset.updateError;
      error.querySelector(".jsCartRetry").hidden = !retry;
      if (invalid) {
        const focus = this.changeContext?.line || this.changeContext?.focus;
        const line = Array.from(this.querySelectorAll(".jsLineItem")).find((item) => item.dataset.key === focus?.key || focus?.identity && item.dataset.cartIdentity === focus.identity);
        const input = line?.querySelector('input[name="updates[]"]');
        if (input) {
          input.setAttribute("aria-invalid", "true");
          input.setAttribute("aria-describedby", [...new Set([...(input.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean), error.id])].join(" "));
        }
      }
      const status = this.querySelector(".jsCartStatus");
      if (status)
        status.textContent = "";
    }
    onFinished() {
      this.response = null;
    }
    set notify(msg) {
      (async () => {
        const searchParams = new URLSearchParams();
        searchParams.set("q", msg);
        searchParams.set("section_id", "cart-noti");
        let response = await fetch(`${theme.routes.searchUrl}?${searchParams.toString()}`);
        response = await response.text();
        let div = document.createElement("div");
        div.innerHTML = response;
        Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
          document.body.insertAdjacentElement("beforeend", el);
        });
      })();
    }
    get getSubmitButton() {
      return Array.from(this.form.elements).filter((button) => button.type === "submit");
    }
    set loadingState(bool) {
      const buttons = this.getSubmitButton;
      if (bool) {
        buttons.forEach((button) => {
          button.setAttribute("aria-busy", true);
          button.classList.add("disabled");
          button.HTMLTemp = button.innerHTML;
          button.innerHTML = document.querySelector("#svg_loading").innerHTML;
        });
      } else {
        buttons.forEach((button) => {
          button.removeAttribute("aria-busy");
          button.classList.remove("disabled");
          button.innerHTML = button.HTMLTemp;
          button.HTMLTemp = null;
        });
      }
    }
    set successNotify(sections = []) {
      const html = sections[this.sectionList("noti")];
      if (!html)
        return;
      let div = document.createElement("div");
      div.innerHTML = html;
      Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
        document.body.insertAdjacentElement("beforeend", el);
        const isPopup = el.tagName.toLowerCase().includes("popup");
      });
    }
    set updateCartCount(value) {
      this.cartCount = Number.parseInt(String(value).trim(), 10);
      if (!Number.isFinite(this.cartCount))
        this.cartCount = 0;
      document.querySelectorAll(".jsCartCount")?.forEach((item) => {
        item.setAttribute("data-count", this.cartCount);
        if (item.hasAttribute("data-cart-count-text"))
          item.textContent = String(this.cartCount);
      });
    }
  };

  // app/scripts/common/function/recentlyViewed.js
  var { routes: { pageType }, product } = theme;
  (async () => {
    const saver = storage("recently-viewed");
    let result = await saver.get() || [];
    if (pageType == "product") {
      let findExist = result.find((item) => item.handle == product.handle);
      if (findExist) {
        result = result.filter((item) => item.handle != product.handle);
      }
      result.push({
        handle: product.handle,
        expired: (/* @__PURE__ */ new Date()).getTime()
      });
      saver.set(result);
    }
    customElements.define("recently-viewed", class recentlyViewed extends HTMLElement {
      connectedCallback() {
        this.arrObject = result.reverse();
        if (this.arrObject.length > +this.dataset.limit)
          this.arrObject.length = +this.dataset.limit;
        this.arrObject = this.arrObject.reverse();
        const promiseArr = [];
        this.arrObject.length && this.arrObject.forEach((obj) => {
          if (pageType == "product" && obj.handle == product.handle)
            return;
          promiseArr.push(this.getProduct(obj.handle));
        });
        Promise.all(promiseArr).then((html) => {
          this.render = html.join(" ");
        });
      }
      getProduct(handle) {
        return new Promise((resolved, rejected) => {
          const productUrl = `products/${handle}?`;
          fetch(this.dataset.url.replace("?", productUrl)).then((e) => e.text()).then((e) => resolved(e.split("<!-- split -->")[1]));
        });
      }
      set render(value) {
        if (!value.length)
          return;
        this.querySelector(".jsContainer").innerHTML = value;
        this.classList.remove("none");
        this.querySelector("slider-component")?.createSlide();
        saver.set(this.arrObject);
      }
    });
  })();

  // app/scripts/common/component/details.js
  var Accordion = class {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector(":scope > summary");
      this.close = el.querySelector(".js-details-close");
      this.content = el.querySelector(":scope > *:not(summary)");
      this.wrapper = el.closest(".jsAccordionWrapper");
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
      if (this.close) {
        this.close.closest("details") == this.el && this.close.addEventListener("click", (e) => this.onClick(e));
      }
      this.el.classList.add("accordion-initialized");
    }
    onClick(e) {
      const link = e.target.closest?.("a[href]");
      const href = link?.getAttribute("href")?.trim();
      if (this.el.closest(".mobile-menu-accordion") && link && this.summary.contains(link) && href && href !== "#" && !/^javascript:/i.test(href))
        return;
      e.preventDefault();
      e.stopPropagation();
      this.trackCartFocus();
      this.el.style.overflow = "hidden";
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
    trackCartFocus() {
      this.cancelCartFocus();
      const component = this.el.parentElement;
      const drawer = component.matches("accordion-component.cart-drawer-note") && component.closest("cart-drawer-component");
      const region = drawer ? component.closest(".popup-footer") : component.matches("accordion-component.cart-summary") && component.closest("main cart-component .cart-sidebar");
      this.cartFocus = region ? {region, drawer, target: null, tab: false, cleanup: null} : null;
      const pending = this.cartFocus;
      if (!pending || !this.summary.contains(document.activeElement)) return;
      const cancel = () => this.cancelCartFocus(pending);
      const key = (event) => {
        if (event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey) pending.tab = true;
        else cancel();
      };
      const keyup = () => pending.tab = false;
      const focus = (event) => {
        if (!pending.tab || !this.isNativeCartControl(event.target, pending)) { cancel(); return; }
        pending.tab = false;
        pending.target = event.target;
      };
      const events = ["pointerdown", "click", "input", "change", "wheel"];
      document.addEventListener("keydown", key, true);
      document.addEventListener("keyup", keyup, true);
      document.addEventListener("focusin", focus, true);
      events.forEach((name) => document.addEventListener(name, cancel, true));
      window.addEventListener("blur", cancel);
      pending.cleanup = () => {
        document.removeEventListener("keydown", key, true);
        document.removeEventListener("keyup", keyup, true);
        document.removeEventListener("focusin", focus, true);
        events.forEach((name) => document.removeEventListener(name, cancel, true));
        window.removeEventListener("blur", cancel);
      };
    }
    cancelCartFocus(pending = this.cartFocus) {
      if (!pending) return;
      pending.cleanup?.();
      pending.cleanup = null;
      pending.target = null;
      pending.tab = false;
    }
    isNativeCartControl(target, pending) {
      return target?.isConnected && pending.region.isConnected && pending.region.contains(target) && (this.el.open || !this.content?.contains(target)) && target.matches("a[href],button,input,select,textarea,summary") && !target.matches(":disabled") && !target.closest('.additional-checkout-buttons,[hidden],[inert],[aria-hidden="true"]') && target.getClientRects().length && getComputedStyle(target).visibility !== "hidden";
    }
    revealCartFocus() {
      const pending = this.cartFocus, target = pending?.target;
      this.cartFocus = null;
      this.cancelCartFocus(pending);
      if (!target || document.activeElement !== target || !this.isNativeCartControl(target, pending)) return;
      const rect = target.getBoundingClientRect();
      let top = 0, bottom = window.innerHeight;
      if (pending.drawer) {
        const box = pending.drawer.getBoundingClientRect();
        top = Math.max(top, box.top + pending.drawer.clientTop);
        bottom = Math.min(bottom, box.top + pending.drawer.clientTop + pending.drawer.clientHeight);
      } else {
        const header = document.querySelector("body > header");
        if (header?.getClientRects().length && getComputedStyle(header).visibility !== "hidden") {
          const box = header.getBoundingClientRect();
          if (box.right > rect.left && box.left < rect.right && box.top <= top && box.bottom > top) top = box.bottom;
        }
      }
      if (bottom <= top || rect.height <= 0) return;
      const inset = bottom - top >= rect.height + 12 ? 6 : 0;
      top += inset;
      bottom -= inset;
      const delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
      if (Math.abs(delta) <= 0.5) return;
      // The document viewport alone does not account for a covering header.
      // Adjust only the native cart's vertical scroller using its usable bounds.
      if (pending.drawer)
        pending.drawer.scrollTop = Math.max(0, Math.min(pending.drawer.scrollHeight - pending.drawer.clientHeight, pending.drawer.scrollTop + delta));
      else
        window.scrollBy({top: delta, behavior: "instant"});
    }
    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.el.classList.add("is-closing");
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      const pending = this.cartFocus;
      this.animation.oncancel = () => { this.isClosing = false; this.cancelCartFocus(pending); };
    }
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      const pending = this.cartFocus;
      window.requestAnimationFrame(() => {
        // A second cart activation can replace this transition before its frame.
        if (!pending || this.cartFocus === pending) this.expand();
      });
    }
    expand() {
      // An option can close the disclosure before its opening frame runs.
      if (!this.el.open) {
        this.onAnimationFinish(false);
        return;
      }
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      const pending = this.cartFocus;
      this.animation.oncancel = () => { this.isExpanding = false; this.cancelCartFocus(pending); };
    }
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = "";
      this.el.classList.remove("is-closing");
      this.wrapper?.classList.toggle("accordion-showing", open);
      const focused = document.activeElement;
      if (open && this.el.closest(".mobile-menu-accordion") && this.content?.contains(focused) && !focused.closest('[hidden],[inert],[aria-hidden="true"]') && focused.getClientRects().length && getComputedStyle(focused).visibility !== "hidden")
        focused.scrollIntoView?.({behavior: "instant", block: "nearest", inline: "nearest"});
      this.revealCartFocus();
    }
  };
  var selectors = {
    activeList: document.querySelectorAll("details[open]:not(.noJS)")
  };
  document.addEventListener("click", (e) => {
    if (!selectors.activeList.length)
      return;
    !e.target.closest("details") && selectors.activeList.forEach((j) => {
      if (j.closest(".accordion-initialized"))
        return;
      j.open = false;
    });
  });
  window.customElements.define("accordion-component", class extends HTMLElement {
    constructor() {
      super();
      if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
        const { debounceTime: debounceTime2 } = theme;
        const debounce = debounceTime2((e) => this.changeState(e), 300);
        window.addEventListener("resize", debounce.bind(this));
      }
    }
    connectedCallback() {
      this.Accordion = new Accordion(this.querySelector("details"));
      this.changeState();
    }
    changeState() {
      this.hasAttribute("data-open-screen") && window.matchMedia(this.getAttribute("data-open-screen")).matches && (this.querySelector("details").open = true);
      this.hasAttribute("data-close-screen") && window.matchMedia(this.getAttribute("data-close-screen")).matches && (this.querySelector("details").open = false);
    }
  });

  // app/scripts/common/function/currencies.js
  var multiCurrency = {};
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  var currencies_default = multiCurrency;

  // app/scripts/common/component/priceComponent.js
  var moneyElement = class extends HTMLElement {
    constructor() {
      super();
      this.value = +this.dataset.value;
      this.content = this.lastElementChild || this;
    }
    get() {
      return this.value;
    }
    set(value) {
      this.value = value;
      if (!this.classList.contains("jsRequiredValue") && value == 0) {
        this.content.innerHTML = "";
        return;
      }
      let currencyFormat = this.dataset.format || theme.settings.currencyFormat || "money_format";
      let f = currencies_default.moneyFormats[theme.settings.currency][currencyFormat] || "{{amount}}";
      this.content.innerHTML = currencies_default.formatMoney(value, f);
    }
  };
  customElements.define("price-component", moneyElement);

  // app/scripts/common/component/popupComponent.js
  customElements.define("popup-component", class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("keydown", (e) => {
        if (!this.isActive || e.defaultPrevented || e.target.closest("popup-component") !== this) return;
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          const details = e.target.closest('details[open]');
          if (details) {
            details.open = false;
            details.querySelector(':scope > summary')?.focus();
            return;
          }
          this.close();
        } else if (e.key === "Tab" && this.isModal) {
          const items = this.focusableItems();
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) {
            e.preventDefault();
            this.focus();
          } else if (e.shiftKey && (document.activeElement === first || document.activeElement === this)) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let className = this.dataset.className?.split(",") || [];
      className.push("active");
      this.classes = {
        className
      };
      this.isModal = this.id !== "compareMiniPopup";
      this.setAttribute("role", this.isModal ? "dialog" : "region");
      this.setAttribute("tabindex", "-1");
      this.inert = this.getAttribute("aria-hidden") !== "false";
      if (this.inert) this.removeAttribute("aria-modal");
      if (!this.hasAttribute("aria-label") && !this.hasAttribute("aria-labelledby")) {
        const heading = this.querySelector("h1,h2,h3,h4,h5,h6,.popup-title,.cart-title");
        if (heading) {
          theme.popupHeadingId = (theme.popupHeadingId || 0) + 1;
          heading.id ||= `${this.id || "theme-popup"}-${theme.popupHeadingId}-title`;
          this.setAttribute("aria-labelledby", heading.id);
        } else {
          this.setAttribute("aria-label", window.espAccessibilityStrings?.dialog || "Dialog");
        }
      }
      this.addEventListener("click", (e) => {
        const currentTarget = e.target;
        if (currentTarget.closest("popup-component") !== this) return;
        if (!currentTarget.closest(".popup__content") && !currentTarget.closest(".jsContent") || currentTarget.closest(".jsClose"))
          this.close();
      });
      this.appendDocument();
      this.autoShow();
    }
    focusableItems() {
      return [...this.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,iframe,[tabindex],[contenteditable="true"]')].filter((el) => {
        if (el.matches(':disabled') || el.tabIndex < 0 || el.closest('[inert],[hidden],[aria-hidden="true"]') || !el.getClientRects().length || getComputedStyle(el).visibility === "hidden") return false;
        // Native Tab skips collapsed content even when it reports rectangles.
        for (let ancestor = el.parentElement; ancestor; ancestor = ancestor.parentElement) {
          if (ancestor.tagName === 'DETAILS' && !ancestor.open && !ancestor.querySelector(':scope > summary')?.contains(el)) return false;
        }
        return true;
      });
    }
    setBackgroundInert() {
      this.backgroundState = [];
      let branch = this;
      while (branch.parentElement && branch !== document.body) {
        [...branch.parentElement.children].forEach((sibling) => {
          if (sibling === branch || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName) || sibling.matches('[role="status"],[role="alert"]')) return;
          this.backgroundState.push([sibling, sibling.inert]);
          sibling.inert = true;
        });
        branch = branch.parentElement;
      }
    }
    restoreBackground() {
      this.backgroundState?.forEach(([element, wasInert]) => element.inert = wasInert);
      this.backgroundState = [];
    }
    close() {
      if (!this.isActive) return;
      clearTimeout(this.focusTimer);
      clearTimeout(this.isHiding);
      this.classList.remove(...this.classes.className);
      this.setAttribute("aria-hidden", true);
      this.removeAttribute("aria-modal");
      this.restoreBackground();
      this.inert = true;
      if (!document.querySelector('popup-component[aria-modal="true"][aria-hidden="false"]'))
        document.body.classList.remove("show-popup");
      this.isActive = null;
      this.syncTriggers(false);
      if (this.focusedElementBeforeModal?.isConnected && !this.focusedElementBeforeModal.closest("[inert]")) {
        this.focusedElementBeforeModal.focus();
      } else {
        document.getElementById("main-content")?.focus();
      }
    }
    open(callback = null) {
      if (this.isActive) { callback?.(); return; }
      theme.prepareMobileNavigation?.(this);
      document.querySelectorAll('popup-component[aria-modal="true"][aria-hidden="false"]').forEach((popup) => {
        if (popup !== this && !popup.contains(this)) popup.close();
      });
      this.focusedElementBeforeModal = document.activeElement;
      this.inert = false;
      this.classList.add(...this.classes.className);
      this.setAttribute("aria-hidden", false);
      if (this.isModal) {
        this.setAttribute("aria-modal", "true");
        this.setBackgroundInert();
        document.body.classList.add("show-popup");
      }
      this.isActive = true;
      this.syncTriggers(true);
      this.focusTimer = setTimeout(() => {
        if (this.isActive && this.isModal) (this.focusableItems()[0] || this).focus();
      }, 100);
      callback && callback();
    }
    syncTriggers(open) {
      if (!this.id) return;
      document.querySelectorAll(`[data-control="#${CSS.escape(this.id)}"]`).forEach((trigger) => {
        trigger.setAttribute("aria-expanded", String(open));
        trigger.setAttribute("aria-controls", this.id);
        trigger.classList.toggle("active", open);
      });
    }
    disconnectedCallback() {
      clearTimeout(this.focusTimer);
      clearTimeout(this.isHiding);
      this.mobileNavigationResizeObserver?.disconnect();
      cancelAnimationFrame(this.mobileNavigationFocusFrame);
      this.restoreBackground();
      this.isActive = false;
      if (!document.querySelector('popup-component[aria-modal="true"][aria-hidden="false"]')) document.body.classList.remove('show-popup');
    }
    toggle(callback = null) {
      this.isActive ? this.close() : this.open();
      callback && callback({ isActive: Boolean(this.isActive) });
    }
    appendDocument() {
      if (!this.hasAttribute("append-body"))
        return;
      this.removeAttribute("append-body");
      const existingNode = document.getElementById(this.id);
      if (existingNode && existingNode !== this) {
        existingNode.after(this);
        existingNode.remove();
      }
    }
    autoShow() {
      if (!this.hasAttribute("append-auto"))
        return;
      this.removeAttribute("append-auto");
      setTimeout(() => {
        this.open();
      }, 300);
    }
    autoHide() {
      if (!this.hasAttribute("auto-hide"))
        return;
      if (this.isHiding != null)
        clearTimeout(this.isHiding);
      this.isHiding = setTimeout(() => {
        this.close();
        this.isHiding = null;
      }, +this.getAttribute("auto-hide"));
    }
  });

  // app/scripts/common/component/quantity.js
  customElements.define("quantity-input", class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event("change", { bubbles: true });
      this.input = this.querySelector("input");
      if (this.input) {
        this.querySelectorAll("button")?.forEach((button) => {
          button.addEventListener("click", this.onButtonClick.bind(this));
        });
        this.input.addEventListener("change", () => {
          this.classList.toggle("is-max-reached", +this.input.value >= +this.input.max);
        });
      } else {
        this.querySelector("select")?.addEventListener("change", (e) => {
          this.dispatchEvent(this.changeEvent);
        });
      }
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      if (this.classList.contains("synchro-input")) {
        if (event.target.name === "plus") {
          document.querySelectorAll(".synchro-input input").forEach((e) => {
            e.stepUp();
          });
        } else {
          document.querySelectorAll(".synchro-input input").forEach((e) => {
            e.stepDown();
          });
        }
      } else {
        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      }
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  });

  // app/scripts/common/component/quickShop.js
  customElements.define("product-card", class extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".jsQuickShop").forEach((item) => {
        item.addEventListener("click", () => {
          this.onFetchQuickShop(item);
        });
      });
    }
    async onFetchQuickShop(button) {
      const url = button.dataset.quickshopUrl;
      document.body.classList.add("event-none");
      let result = await fetch(url);
      result = await result.text();
      result = result.split("<!-- split -->")[1];
      document.body.insertAdjacentHTML("beforeend", result);
      document.body.classList.remove("event-none");
    }
  });

  // app/scripts/common/component/productCart.js
  var productCartForm = class extends cartForm {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form?.addEventListener("submit", this.onSubmit.bind(this));
    }
    capitalizeFirstLetter(val) {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
    onSubmit(event) {
      event.preventDefault();
      if (this.isAdding)
        return;
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      const formData = new FormData(this.form);
      if (localStorage.getItem("utm_source") || window.location.href.includes("utm_source=")) {
        const params = new URL(window.location.href).searchParams;
        const utmSource = localStorage.getItem("utm_source") || params.get("utm_source");
        formData.append(`properties[${this.capitalizeFirstLetter(utmSource)}Store]`, "");
      }
      formData.append("sections", this.sectionList());
      formData.append("sections_url", this.dataset.url || location.pathname);
      return this.cartAdd(formData);
    }
    validateCartAddSections(sections) {
      const drawer = document.querySelector("cart-drawer-component");
      if (!drawer)
        return;
      const html = sections[drawer.sectionName];
      if (typeof html !== "string")
        throw new Error("Cart drawer section unavailable");
      const template = document.createElement("template");
      template.innerHTML = html;
      if (!template.content.querySelector(drawer.tagName))
        throw new Error("Cart drawer content unavailable");
    }
    onUpdating(response) {
      if (!response.isSuccess)
        return;
      const drawerExist = document.querySelector("cart-drawer-component");
      if (drawerExist) {
        drawerExist.refresh = response.sections;
        drawerExist.open = true;
      }
    }
  };
  customElements.define("product-cart-form", productCartForm);

  // app/scripts/common/component/productForm.js
  var { inViewPort, addEvent: addEvent5 } = theme;
  !window.customElements.get("product-form") && customElements.define("product-form", class productForm extends HTMLElement {
    connectedCallback() {
      this.scriptElement = this.querySelector('script[type="application/json"].object-product');
      this.JSON = this.scriptElement ? JSON.parse(this.scriptElement.textContent).product : window.theme.product;
      this.linkOptions();
      this.variantChangeHandler ||= this.onChange.bind(this);
      this.addEventListener("change", this.variantChangeHandler);
      this.template = this.querySelector("#productTemplate")?.content || null;
      this.swatchClickHandler ||= (event) => {
        if (event.target.matches('input.js-variant-change[type="radio"]') && event.target.checked) this.finishSwatchSelection(event.target);
      };
      this.addEventListener("click", this.swatchClickHandler);
      const stickyEl = this.querySelector(".jsStickyTarget");
      window.addEventListener("load", () => {
        inViewPort(stickyEl, (boolean) => {
          let value = boolean;
          if (stickyEl.getBoundingClientRect().top >= window.scrollY) {
            value = true;
          }
          this.closest(".shopify-section").classList.toggle("product-form-visible", value);
        }, false);
      });
    }
    finishSwatchSelection(input) {
      const item = input.closest('.swt-item');
      const details = item?.closest('details');
      const summary = details?.querySelector(':scope > summary');
      if (!summary || !this.contains(details)) return;
      const restoreFocus = details.contains(document.activeElement);
      const label = summary.querySelector('.label');
      if (label) label.textContent = item.querySelector('.swt-value')?.textContent || input.value;
      const accordion = details.closest('accordion-component')?.Accordion;
      if (accordion?.el === details) {
        accordion.animation?.cancel();
        accordion.onAnimationFinish(false);
      } else details.open = false;
      if (restoreFocus) summary.focus({preventScroll: true});
    }
    onChange(event) {
      const target = event.target;
      if (!target.classList.contains("js-variant-change"))
        return;
      if (target.matches('input[type="radio"]') && target.checked) this.finishSwatchSelection(target);
      let index = +target.name.replace(/[^\d]/g, "");
      if (index == 1) {
        this.updateOptionsInSelector(2);
        this.updateOptionsInSelector(3);
      }
      if (index == 2) {
        this.updateOptionsInSelector(3);
      }
      if (!this.getVariant())
        return;
      this.updateMedia();
      this.updateURL();
      if (this.currentVariant) {
        this.updateId();
        this.updateContent();
      } else {
        this.setUnavailable();
      }
      this.closest("[data-section-id]").classList.toggle("variant-soldout", !this.currentVariant?.available || false);
      const { swatchId } = target.dataset;
      this.querySelector(swatchId)?.classList.remove("active");
      this.currentVariant && window.dispatchEvent(new CustomEvent("variant:change", {
        detail: {
          variant: this.currentVariant
        }
      }));
    }
    updateId() {
      if (this.currentVariant && this.currentVariant.available) {
        const masterID = this.querySelector('[name="id"]');
        masterID.tagName == "SELECT" && (masterID.value = this.currentVariant.id);
      }
    }
    getCurrentOptions() {
      let currentOptions = [];
      this.JSON.options.forEach((option, index) => {
        let optionName = `[name="option${index + 1}"]`;
        if (this.querySelector(optionName).tagName == "INPUT") {
          currentOptions.push(this.querySelector(optionName + ":checked")?.value);
        } else {
          currentOptions.push(this.querySelector(optionName)?.value);
        }
      });
      return currentOptions;
    }
    getVariant() {
      const options = this.getCurrentOptions();
      this.currentVariant = this.JSON.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });
      if (!this.currentVariant) {
        let selectOptions = Array.from(
          document.querySelectorAll("select[name*=option], input[name*=option]:checked")
        ).filter((i) => i != null);
        if (this.JSON.options.length != selectOptions.length)
          return false;
      }
      return true;
    }
    updateURL() {
      if (!this.currentVariant)
        return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateContent() {
      if (!this.currentVariant)
        return;
      const template = this.template.querySelector(`[data-variant-id="${this.currentVariant.id}"]`);
      document.querySelectorAll(".jsProductUpdate").forEach((node) => {
        const target = template?.querySelector(`[class*="${node.className}"]`);
        if (!target)
          return;
        if (node.classList.contains("jsProductReplace")) {
          node.replaceWith(target);
        } else
          node.innerHTML = target.innerHTML;
      });
    }
    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media)
        return;
      const index = this.currentVariant.featured_media.position - 1;
      document.querySelector("product-slider-component.js-slider-main")?.goTo(index);
    }
    setUnavailable() {
      this.querySelectorAll(".add-to-cart")?.forEach((item) => {
        item.innerHTML = theme.strings.unavailable;
      });
    }
    linkOptions() {
      this.optionsMap = {};
      this.availableOptions = {};
      for (var i = 0; i < this.JSON?.variants.length; i++) {
        let variant = this.JSON.variants[i];
        this.optionsMap["root"] = this.optionsMap["root"] || [];
        this.optionsMap["root"].push(variant.option1);
        this.optionsMap["root"] = [...new Set(this.optionsMap["root"])];
        if (this.JSON.options.length > 1) {
          var key = variant.option1;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option2);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (this.JSON.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option3);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (variant.available) {
          this.availableOptions["root"] = this.availableOptions["root"] || [];
          this.availableOptions["root"].push(variant.option1);
          this.availableOptions["root"] = [...new Set(this.availableOptions["root"])];
          if (this.JSON.options.length > 1) {
            var key = variant.option1;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option2);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
          if (this.JSON.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option3);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
        }
      }
      if (!Array.from(document.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter(
        (i2) => i2 != null
      ).length)
        return;
      this.updateOptionsInSelector(1);
      this.JSON.options.length > 1 && this.updateOptionsInSelector(2);
      this.JSON.options.length === 3 && this.updateOptionsInSelector(3);
    }
    updateOptionsInSelector(index) {
      let key;
      let selector;
      const optionEl = {
        option1: Array.from(document.querySelectorAll("select[name=option1], input[name=option1]:checked")).find(
          (i) => i != null
        ),
        option2: Array.from(document.querySelectorAll("select[name=option2], input[name=option2]:checked")).find(
          (i) => i != null
        ),
        option3: Array.from(document.querySelectorAll("select[name=option3], input[name=option3]:checked")).find(
          (i) => i != null
        )
      };
      switch (index) {
        case 1:
          key = "root";
          selector = optionEl.option1;
          break;
        case 2:
          key = optionEl.option1?.value;
          selector = optionEl.option2;
          break;
        default:
          key = optionEl.option1?.value;
          selector = optionEl.option3;
          key += " / " + optionEl.option2?.value;
          index = 3;
      }
      if (!selector) {
        selector = Array.from(document.querySelectorAll(`select[name=option${index}], input[name=option${index}]`)).find(
          (i) => i != null
        );
      }
      const availableOptions = this.optionsMap[key] || [];
      const optionsValid = this.availableOptions[key] || [];
      const initialValue = selector?.value || "null";
      if (!selector)
        return;
      if (selector.tagName == "SELECT") {
        Array.from(selector.querySelectorAll("option")).forEach((option) => {
          availableOptions.includes(option.value) ? option.removeAttribute("hidden") : option.setAttribute("hidden", "");
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          selector.value = availableOptions[0];
        }
      } else {
        Array.from(this.querySelectorAll(`[name=${selector.name}]`)).forEach((input) => {
          input.classList.toggle("disabled", !optionsValid.includes(input.value));
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          const tempInput = document.createElement("input");
          tempInput.type = "text";
          tempInput.value = availableOptions[0];
          const findAvailableInput = Array.from(this.querySelectorAll(`[name=${selector.name}]`)).find(
            (input) => input.value == tempInput.value
          );
          findAvailableInput && (findAvailableInput.checked = true);
        }
      }
    }
  });

  // app/scripts/common/component/lazyScript.js
  var customElementsName = "lazy-script";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      if (!("IntersectionObserver" in window) && !("IntersectionObserverEntry" in window) && !("intersectionRatio" in window.IntersectionObserverEntry.prototype)) {
        this.inVisible();
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.inVisible();
            observer.disconnect();
          }
        });
      });
      observer.observe(this);
    }
    inVisible() {
      setTimeout(() => {
        this.loadFiles();
        this.changeTag();
      }, 100);
    }
    loadFiles() {
      const { file: files } = this.dataset;
      if (!files)
        return;
      this.removeAttribute("data-file");
      files.split(",").forEach((file) => {
        if (file.includes(".js")) {
          const parts = file.split("/");
          const fileName = parts[parts.length - 1].split(".js")[0];
          if (document.querySelector(`script[data-uniq="${fileName}"]`))
            return;
          const script = document.createElement("script");
          script.setAttribute("data-uniq", fileName);
          script.src = file;
          document.head.insertAdjacentElement("beforeend", script);
        } else {
          const parts = file.split("/");
          const fileName = parts[parts.length - 1].split(".css")[0];
          if (document.querySelector(`link[data-uniq="${fileName}"]`))
            return;
          const stylesheet = document.createElement("link");
          stylesheet.href = file;
          stylesheet.rel = "stylesheet";
          stylesheet.type = "text/css";
          stylesheet.media = "all";
          stylesheet.setAttribute("data-uniq", fileName);
          document.head.insertAdjacentElement("beforeend", stylesheet);
        }
      });
    }
    changeTag() {
      const { tag } = this.dataset;
      if (!tag)
        return;
      const el = document.createElement(tag || "div");
      this.removeAttribute("data-tag");
      Array.from(this.attributes).forEach((attr, i) => {
        el.setAttribute(this.attributes[i].name, this.attributes[i].value);
      });
      Array.from(this.children)?.forEach((child) => {
        el.insertAdjacentElement("beforeend", child);
      });
      this.insertAdjacentElement("beforebegin", el);
      this.remove();
    }
  });

  // app/scripts/common/component/videoComponent.js
  customElements.define("video-component", class videoComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.addEventListener("touchstart", (e) => e.stopPropagation(), { passive: true });
      this.addEventListener("touchmove", (e) => e.stopPropagation());
      this.addEventListener("touchend", (e) => e.stopPropagation());
      this.addEventListener("mousedown", (e) => e.stopPropagation());
    }
    togglePlay() {
      const { inViewPort: inViewPort2 } = theme;
      this.hasAttribute("play-in-view") && inViewPort2(this, (e) => {
        e ? this.playVideo() : this.stopVideo();
      });
    }
    init() {
      const { type } = this.dataset;
      switch (type) {
        case "youtube":
          this.loadYoutube();
          break;
        case "vimeo":
          this.loadVimeo();
          break;
        case "video":
          this.loadNative();
          break;
      }
    }
    playVideo() {
      if (this.isPlaying)
        return;
      this.isPlaying = true;
      this.classList.add("playing");
      this.videoPlay();
    }
    stopVideo(arg) {
      if (!this.isPlaying)
        return;
      this.classList.remove("playing");
      this.videoStop(arg);
      this.isPlaying = false;
    }
    loadYoutube() {
      if (document.querySelector(`script[src*=youtube][src*=iframe_api]`)) {
        this.loadYoutubeVideo();
        return;
      }
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    loadYoutubeVideo() {
      if (typeof YT == "undefined")
        return;
      const video = this.querySelector("iframe");
      const defaultConfig = `{ "autoplay": 0, "playsinline": 1, "controls": 0, "showinfo": 0, "rel": 0, "loop": 1 }`;
      const playerVars = JSON.parse(video.dataset.config || defaultConfig);
      video.media = new YT.Player(video.id, {
        videoId: video.dataset.ytId,
        playerVars,
        events: {
          "onReady": onPlayerReady.bind(this),
          "onStateChange": onPlayerStateChange.bind(this)
        }
      });
      this.videoPlay = () => {
        video.media?.playVideo();
      };
      this.videoStop = (restart = null) => {
        video.media?.pauseVideo();
        restart && video.media.seekTo(0);
      };
      function onPlayerReady(event) {
        let video2 = event.target;
        const iframe = video2.getIframe();
        if (!iframe.classList.contains("jsAutoPlay"))
          return;
        video2.mute();
        video2.playVideo();
      }
      function onPlayerStateChange(event) {
        const video2 = event.target;
        switch (event.data) {
          case YT.PlayerState.PLAYING:
            this.playVideo();
            break;
          case YT.PlayerState.PAUSED:
            this.stopVideo();
            break;
          case YT.PlayerState.ENDED:
            this.stopVideo(true);
            break;
          default:
            break;
        }
      }
      this.togglePlay();
    }
    loadVimeo() {
      if (document.querySelector(`script[src*=vimeo][src*=player]`)) {
        this.loadVimeoVideo();
        return;
      }
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.id = "VMScript";
      tag.onload = this.loadVimeoVideo.bind(this);
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    loadVimeoVideo() {
      if (typeof Vimeo == "undefined")
        return;
      const video = this.querySelector("iframe");
      video.media = new Vimeo.Player(video);
      video.classList.contains("jsAutoPlay") && (video.media.setVolume(0), video.media.play());
      this.videoPlay = () => {
        video.media.play();
      };
      this.videoStop = () => {
        video.media.pause();
      };
      video.media.on("play", () => {
      });
      video.media.on("ended", () => {
        video.media.play();
      });
      this.togglePlay();
    }
    loadNative() {
      const video = this.querySelector("video");
      this.videoPlay = () => {
        video.play();
      };
      this.videoStop = () => {
        video.pause();
      };
      this.togglePlay();
    }
  });
  window["onYouTubeIframeAPIReady"] = () => {
    const selectors2 = `video-component[data-type="youtube"]`;
    document.querySelectorAll(selectors2)?.forEach((video) => video.loadYoutubeVideo());
  };

  // app/scripts/common/component/stickyHeader.js
  var StickyHeader = class extends HTMLElement {
    constructor() {
      super();
      const stickyDirection = this.dataset.sticky || "down";
      stickyDirection == "up" && this.closest("header").setAttribute("data-sticky", "up");
      this.removeAttribute("data-sticky1");
    }
    connectedCallback() {
      this.header = document.querySelector("header");
      this.headerBounds = this.header.getBoundingClientRect();
      this.currentScrollTop = this.header.getBoundingClientRect().bottom || 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      this.createObserver();
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer2) => {
        this.headerBounds = entries[0].intersectionRect;
        observer2.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add("header-sticky", "is-scrolling-down");
      this.header.classList.remove("is-scrolling-up");
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      this.header.classList.add("header-sticky", "is-scrolling-up");
      this.header.classList.remove("is-scrolling-down");
    }
    reset() {
      this.header.classList.remove("header-sticky", "is-scrolling-up");
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure");
      this.disclosures?.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector("details-modal");
      this.searchModal?.close(false);
    }
  };
  !customElements.get("sticky-header") && customElements.define("sticky-header", StickyHeader);

  // app/scripts/common/component/stickyMobileBar.js
  var stickyMobileBar = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.documentElement.style.setProperty("--padding-bottom", this.scrollHeight + "px");
    }
  };
  !customElements.get("sticky-mobile-bar") && customElements.define("sticky-mobile-bar", stickyMobileBar);

  // app/scripts/common/component/headerMobile.js
  var { resizeObserver } = theme;
  !window.customElements.get("mobile-menu") && window.customElements.define("mobile-menu", class extends HTMLElement {
    constructor() {
      super();
      resizeObserver(this, () => {
        if (this.clientWidth == 0) {
          this.closest("popup-component").close();
        }
      }, 300);
    }
    onClick(el) {
      const nav = el;
      const parentNode = nav.closest(".list-item");
      const details = parentNode.querySelector("details");
      if (parentNode.closest(".has-dropdown")) {
        if (parentNode.classList.contains("active")) {
          details.removeAttribute("open");
        } else {
          details.setAttribute("open", "");
        }
        parentNode.classList.toggle("active", !parentNode.classList.contains("active"));
        return;
      }
      const template = parentNode.querySelector(".jsTemplate");
      if (!template)
        return;
      template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
        template.insertAdjacentElement("beforebegin", child);
      });
      template.tagName == "NOSCRIPT" && template.insertAdjacentHTML("beforebegin", template.textContent);
      template.remove();
      parentNode.classList.add("has-dropdown", "active");
      details.setAttribute("open", "");
      parentNode.querySelector(":scope > a ~ template")?.remove();
    }
  });

  // app/scripts/common/function/header.js
  var header_default = Header = {
    init() {
      const container = document.querySelector('[data-section-type="header-section"]');
      if (!container || this.container === container && this.headerEvents && !this.headerEvents.signal.aborted) return;
      this.headerEvents?.abort();
      clearTimeout(this.navFocusTimer);
      this.headerObserver?.disconnect();
      this.container = container;
      this.headerEvents = new AbortController();
      const { signal } = this.headerEvents;
      this.navItems = new Map();
      this.navigationId ||= 0;
      const filterManuals2 = this.container.querySelector(".find-r");
      const sectionNavigation = this.container.querySelector(".section-navigation");
      const finderButton = filterManuals2?.querySelector(".js-btn-find-replacement");
      const finderPanel = filterManuals2?.querySelector("filter-manuals");
      const setFinder = (open, restore = false) => {
        if (!finderButton || !finderPanel) return;
        sectionNavigation?.classList.toggle("is-open", open);
        finderButton.setAttribute("aria-expanded", String(open));
        finderPanel.hidden = !open;
        finderPanel.inert = !open;
        if (restore) finderButton.focus();
      };
      if (finderButton && finderPanel) {
        finderPanel.id = "header-finder-" + (this.container.dataset.sectionId || "main");
        finderButton.setAttribute("aria-controls", finderPanel.id);
        finderButton.addEventListener("click", () => setFinder(finderButton.getAttribute("aria-expanded") !== "true"), { signal });
        filterManuals2.addEventListener("keydown", event => {
          if (event.key === "Escape" && !event.defaultPrevented && !event.target.closest("details[open]")) {
            event.preventDefault();
            setFinder(false, true);
          }
        }, { signal });
        filterManuals2.addEventListener("focusout", () => setTimeout(() => {
          if (!filterManuals2.contains(document.activeElement)) setFinder(false);
        }), { signal });
        setFinder(false);
      }
      document.addEventListener("click", event => {
        if (filterManuals2 && !filterManuals2.contains(event.target)) setFinder(false);
      }, { signal });
      this.initNavigation();
      this.setBottomPosition();
      this.container.querySelectorAll(".jsFocus").forEach((item) => {
        item.addEventListener("focusin", (e) => {
          item.classList.add("is-focusing");
        }, { signal });
        item.addEventListener("focusout", (e) => {
          item.classList.remove("is-focusing");
        }, { signal });
      });
    },
    initNavigation() {
      const { signal } = this.headerEvents;
      this.container.querySelectorAll(".section-navigation .main-navigation").forEach((navigation) => {
        this.registerNavigation(navigation);
        navigation.addEventListener("click", (event) => {
          const record = this.navRecord(event.target);
          if (!record || !record.button.contains(event.target) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          record.open ? this.closeNavigation(record, true) : this.openNavigation(record, true);
        }, { signal });
        navigation.addEventListener("keydown", (event) => {
          if (event.defaultPrevented) return;
          let record = this.navRecord(event.target);
          if (event.key === "Escape") {
            while (record && !record.open) record = this.navRecord(record.item.parentElement);
            if (!record) return;
            event.preventDefault();
            event.stopPropagation();
            this.closeNavigation(record, true);
            record.button.focus();
          } else if (record && (event.key === "ArrowDown" || event.key === "ArrowUp") && (record.button.contains(event.target) || record.link === event.target)) {
            event.preventDefault();
            this.openNavigation(record, true);
            const items = this.navigationFocusable(record.panel);
            (event.key === "ArrowUp" ? items.at(-1) : items[0])?.focus();
          }
        }, { signal });
        navigation.addEventListener("focusin", (event) => {
          const record = this.navRecord(event.target);
          // Materialize lazy markup before exposing its controlled ID. Native
          // disclosure buttons open on activation; real links keep their URL.
          if (record) this.onNavHover(record.button);
          this.navItems.forEach((other) => {
            if (other.open && !other.item.contains(event.target) && !other.hovered) this.closeNavigation(other);
          });
        }, { signal });
        navigation.addEventListener("focusout", () => {
          clearTimeout(this.navFocusTimer);
          this.navFocusTimer = setTimeout(() => {
            this.navItems.forEach((record) => {
              if (!record.item.contains(document.activeElement) && !record.hovered) this.closeNavigation(record);
            });
          }, 0);
        }, { signal });
      });
      document.addEventListener("click", (event) => {
        this.navItems.forEach((record) => {
          if (record.open && !record.item.contains(event.target)) this.closeNavigation(record, true);
        });
      }, { signal });
    },
    navRecord(target) {
      let item = target?.closest?.(".list-item");
      while (item) {
        if (this.navItems.has(item)) return this.navItems.get(item);
        item = item.parentElement?.closest(".list-item");
      }
      return null;
    },
    navigationFocusable(panel) {
      return Array.from(panel?.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,iframe,[tabindex],[contenteditable="true"]') || []).filter((item) => {
        if (item.matches(":disabled") || item.tabIndex < 0 || item.closest('[hidden],[inert],[aria-hidden="true"]') || !item.getClientRects().length || getComputedStyle(item).visibility === "hidden") return false;
        for (let ancestor = item.parentElement; ancestor; ancestor = ancestor.parentElement) {
          if (ancestor.tagName === "DETAILS" && !ancestor.open && !ancestor.querySelector(":scope > summary")?.contains(item)) return false;
        }
        return true;
      });
    },
    registerNavigation(root) {
      const items = root.matches(".list-item") ? [root, ...root.querySelectorAll(".list-item")] : root.querySelectorAll(".list-item");
      items.forEach((item) => {
        if (!item.closest(".section-navigation .main-navigation")) return;
        const panels = Array.from(item.children).filter((child) => child.matches(".dropdown, .mega__section"));
        const lazy = Array.from(item.children).some((child) => child.matches(".jsTemplate"));
        let record = this.navItems.get(item);
        if (!record) {
          const link = item.querySelector(":scope > a.list-item-link");
          if (!link || !panels.length && !lazy) return;
          const href = (link.getAttribute("href") || "").trim();
          const placeholder = !href || href === "#" || /^javascript:\s*(?:void\s*\(\s*0\s*\)|;)\s*;?$/i.test(href);
          const button = document.createElement("button");
          button.type = "button";
          if (placeholder) {
            Array.from(link.attributes).forEach((attribute) => {
              if (attribute.name !== "href") button.setAttribute(attribute.name, attribute.value);
            });
            button.append(...link.childNodes);
            link.replaceWith(button);
          } else {
            button.className = "header-nav-toggle";
            button.setAttribute("aria-label", link.getAttribute("title") || link.textContent.trim());
            const icon = link.querySelector(":scope > svg");
            if (icon) button.append(icon);
            else button.textContent = "▾";
            link.after(button);
            item.classList.add("header-nav-has-link");
          }
          button.querySelectorAll("svg").forEach((icon) => icon.setAttribute("aria-hidden", "true"));
          record = { item, link: placeholder ? null : link, button, panel: null, open: false, hovered: false, dismissed: false };
          this.navItems.set(item, record);
          item.dataset.headerDisclosure = "";
          button.setAttribute("aria-expanded", "false");
          item.addEventListener("mouseenter", () => {
            record.hovered = true;
            if (!record.dismissed) this.openNavigation(record);
          }, { signal: this.headerEvents.signal });
          item.addEventListener("mouseleave", () => {
            record.hovered = false;
            record.dismissed = false;
            if (!item.contains(document.activeElement)) this.closeNavigation(record);
          }, { signal: this.headerEvents.signal });
        }
        const panel = panels.find((child) => child.matches(".mega__section")) || panels[0];
        if (!panel || record.panel === panel) return;
        record.panel = panel;
        if (!panel.id) {
          do { panel.id = `header-navigation-${++this.navigationId}`; }
          while (document.querySelectorAll(`#${panel.id}`).length > 1);
        }
        record.button.setAttribute("aria-controls", panel.id);
        if (record.link) {
          record.link.setAttribute("aria-controls", panel.id);
          record.link.setAttribute("aria-expanded", String(record.open));
        }
        panels.forEach((child) => {
          child.dataset.headerNavigationPanel = "";
          child.hidden = child !== panel || !record.open;
          child.inert = child.hidden;
          child.setAttribute("aria-hidden", String(child.hidden));
        });
      });
    },
    openNavigation(record, explicit = false) {
      if (record.dismissed && !explicit) return;
      // A passing pointer must not hide a different branch containing keyboard
      // focus. An explicit disclosure activation can intentionally switch it.
      if (!explicit && Array.from(this.navItems.values()).some((other) => other.open && other.item.contains(document.activeElement) && !other.item.contains(record.item) && !record.item.contains(other.item))) return;
      this.onNavHover(record.button);
      if (!record.panel) return;
      const parent = this.navRecord(record.item.parentElement);
      if (parent && !parent.open) this.openNavigation(parent, explicit);
      if (parent && !parent.open) return;
      this.navItems.forEach((other) => {
        if (other !== record && other.open && !other.item.contains(record.item) && !record.item.contains(other.item)) this.closeNavigation(other, true);
      });
      record.open = true;
      record.dismissed = false;
      record.item.classList.add("is-focusing");
      record.button.setAttribute("aria-expanded", "true");
      record.link?.setAttribute("aria-expanded", "true");
      record.panel.hidden = false;
      record.panel.inert = false;
      record.panel.setAttribute("aria-hidden", "false");
    },
    closeNavigation(record, dismiss = false) {
      this.navItems.forEach((child) => {
        if (child !== record && record.item.contains(child.item)) {
          child.open = false;
          child.dismissed = dismiss;
          child.item.classList.remove("is-focusing");
          child.button.setAttribute("aria-expanded", "false");
          child.link?.setAttribute("aria-expanded", "false");
          if (child.panel) {
            child.panel.hidden = true;
            child.panel.inert = true;
            child.panel.setAttribute("aria-hidden", "true");
          }
        }
      });
      record.open = false;
      record.dismissed = dismiss;
      record.item.classList.remove("is-focusing");
      record.button.setAttribute("aria-expanded", "false");
      record.link?.setAttribute("aria-expanded", "false");
      if (record.panel) {
        record.panel.hidden = true;
        record.panel.inert = true;
        record.panel.setAttribute("aria-hidden", "true");
      }
    },
    onNavHover(el) {
      const item = el.closest(".list-item");
      if (!item) return;
      Array.from(item.children).filter((child) => child.matches(".jsTemplate")).forEach((template) => {
        if (template.tagName === "TEMPLATE") template.before(...template.content.children);
        if (template.tagName === "NOSCRIPT") template.insertAdjacentHTML("beforebegin", template.textContent);
        template.remove();
      });
      this.registerNavigation(item);
      if (this.navItems.get(item)?.panel) item.classList.add("has-dropdown");
    },
    setBottomPosition() {
      const header = this.container.closest("header");
      const { bottom } = header.getBoundingClientRect();
      document.body.style.setProperty("--header-bottom", bottom + "px");
      this.headerObserver = new ResizeObserver(() => {
        const { bottom: bottom2 } = header.getBoundingClientRect();
        document.body.style.setProperty("--header-bottom", bottom2 + "px");
      });
      this.headerObserver.observe(header);
    },
    onLoad: function() {
      this.init();
    }
  };

  // app/scripts/common/component/manual-search.js
  var finderInstance = 0;
  var finderControls = class extends HTMLElement {
    connectFinder() {
      if (this.finderConnected) return false;
      this.finderConnected = true;
      this.resetTypeahead();
      this.fields = Array.from(this.querySelectorAll("details"));
      this.buttonSubmit = this.querySelector(".js-btn-submit");
      this.status = this.querySelector(".finder-status");
      if (!this.status) {
        this.status = document.createElement("p");
        this.status.className = "finder-status esp-visually-hidden";
        this.status.setAttribute("role", "status");
        this.status.setAttribute("aria-live", "polite");
        this.status.setAttribute("aria-atomic", "true");
        this.append(this.status);
      }
      this.finderId ||= `finder-${++finderInstance}`;
      this.fields.forEach((field, index) => {
        const choices = this.choicesContainer(field);
        if (choices) {
          choices.id ||= `${this.finderId}-choices-${index}`;
          field.querySelector("summary")?.setAttribute("aria-controls", choices.id);
        }
      });
      this.finderClick ||= this.onFinderClick.bind(this);
      this.finderKeydown ||= this.onFinderKeydown.bind(this);
      this.finderFocusout ||= (event) => {
        const field = event.target.closest("details");
        // Native Tab can expose BODY between focusout and focusin. Keep the
        // incoming choice visible and inspect completed focus changes later.
        if (field && this.contains(field) && !field.contains(event.relatedTarget)) setTimeout(() => {
          if (this.isConnected && !field.contains(document.activeElement)) {
            field.open = false;
            if (this.typeaheadField === field) this.resetTypeahead();
          }
        }, 0);
      };
      this.finderOutside ||= (event) => {
        if (!this.contains(event.target)) this.closeFields();
      };
      this.finderResize ||= () => {
        if (this.finderResizeFrame) cancelAnimationFrame(this.finderResizeFrame);
        this.finderResizeFrame = requestAnimationFrame(() => {
          this.finderResizeFrame = 0;
          this.revealFocusedChoice();
        });
      };
      this.addEventListener("click", this.finderClick);
      this.addEventListener("keydown", this.finderKeydown);
      this.addEventListener("focusout", this.finderFocusout);
      document.addEventListener("click", this.finderOutside);
      window.addEventListener("resize", this.finderResize);
      return true;
    }
    disconnectedCallback() {
      this.finderConnected = false;
      this.resetTypeahead();
      this.removeEventListener("click", this.finderClick);
      this.removeEventListener("keydown", this.finderKeydown);
      this.removeEventListener("focusout", this.finderFocusout);
      document.removeEventListener("click", this.finderOutside);
      window.removeEventListener("resize", this.finderResize);
      if (this.finderResizeFrame) cancelAnimationFrame(this.finderResizeFrame);
      this.finderResizeFrame = 0;
      this.requestVersion = (this.requestVersion || 0) + 1;
      this.requestController?.abort();
    }
    message(key, fallback, values = {}) {
      let text = window.espAccessibilityStrings?.[key] || fallback;
      Object.entries(values).forEach(([name, value]) => {
        text = text.replace(new RegExp(`{{\\s*${name}\\s*}}`, "g"), String(value));
      });
      return text;
    }
    announce(message) {
      this.status.textContent = message;
    }
    choicesContainer(field) {
      return field?.querySelector(".chosen-drop, .search-result-data");
    }
    resetTypeahead() {
      this.typeahead = "";
      this.typeaheadTime = 0;
      this.typeaheadField = null;
    }
    revealFocusedChoice() {
      const target = document.activeElement;
      const field = target?.closest("details");
      if (!this.isConnected || !this.contains(target) || !field?.open || !this.fields.includes(field) || target.closest("[hidden], [inert], details:not([open])")) return;
      const style = getComputedStyle(target);
      if (style.display === "none" || style.visibility === "hidden" || !target.getClientRects().length) return;
      const bounds = target.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const choices = this.choicesContainer(field);
      const list = choices?.contains(target) ? choices.getBoundingClientRect() : null;
      const outsideWindow = bounds.top < 0 || bounds.bottom > window.innerHeight;
      const outsideList = list && (bounds.top < list.top || bounds.bottom > list.bottom);
      if (outsideWindow || outsideList) target.scrollIntoView({block: "nearest", inline: "nearest", behavior: "instant"});
    }
    closeFields(except) {
      if (this.typeaheadField !== except) this.resetTypeahead();
      this.fields.forEach((field) => { if (field !== except) field.open = false; });
    }
    labelField(field, kind, value) {
      if (!field) return;
      const label = this.message(kind === "brand" ? "finderBrand" : "finderModel", kind === "brand" ? "Brand" : "Model");
      const title = field.querySelector(".js-title");
      if (value != null && title) title.textContent = value;
      field.querySelector("summary")?.setAttribute("aria-label", `${label}: ${title?.textContent.trim() || label}`);
    }
    setDestination(url = "") {
      let valid = "";
      try {
        const parsed = new URL(url, window.location.href);
        if (url && ["http:", "https:"].includes(parsed.protocol)) valid = url;
      } catch (_) {}
      this.buttonSubmit.dataset.url = valid;
      this.buttonSubmit.disabled = !valid;
      this.buttonSubmit.setAttribute("aria-disabled", String(!valid));
    }
    navigate(url) {
      window.location.href = url;
    }
    createChoice(label, url) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "chosen-item finder-choice";
      button.textContent = label;
      button.setAttribute("aria-pressed", "false");
      if (url) button.dataset.url = url;
      return button;
    }
    markChoice(button) {
      button.closest("details").querySelectorAll(".finder-choice").forEach((choice) => {
        choice.classList.toggle("active", choice === button);
        choice.setAttribute("aria-pressed", String(choice === button));
      });
    }
    showMessage(field, message) {
      const paragraph = document.createElement("p");
      paragraph.className = "finder-message";
      paragraph.textContent = message;
      this.choicesContainer(field)?.replaceChildren(paragraph);
    }
    renderModels(field, models) {
      this.setDestination();
      const container = this.choicesContainer(field);
      container.replaceChildren(...models.map((model) => this.createChoice(model.name, model.url)));
      if (!models.length) this.showMessage(field, this.message("finderNoModels", "No models are available for this brand."));
    }
    selectModel(button, field) {
      this.resetTypeahead();
      this.markChoice(button);
      this.labelField(field, "model", button.textContent.trim());
      this.setDestination(button.dataset.url);
      field.open = false;
      field.querySelector("summary").focus();
      this.announce(this.buttonSubmit.disabled ? this.message("finderNoModels", "No models are available for this brand.") : this.message("finderSelected", "{{ model }} selected. Search is ready.", { model: button.textContent.trim() }));
    }
    onFinderClick(event) {
      const submit = event.target.closest(".js-btn-submit");
      if (submit === this.buttonSubmit) {
        event.preventDefault();
        if (!submit.disabled && submit.dataset.url) this.navigate(submit.dataset.url);
        return;
      }
      const summary = event.target.closest("summary");
      if (summary && this.contains(summary)) {
        this.resetTypeahead();
        this.closeFields(summary.closest("details"));
      }
      const choice = event.target.closest(".finder-choice");
      if (choice && this.contains(choice)) this.selectChoice(choice);
      const system = event.target.closest(".sys-btn");
      if (system && this.contains(system)) this.selectSystem?.(system);
      if (event.target.closest(".finder-retry")) this.loadData?.();
    }
    onFinderKeydown(event) {
      const field = event.target.closest("details");
      if (!field || !this.contains(field)) return;
      const summary = field.querySelector("summary");
      if (event.key === "Escape" && field.open) {
        this.resetTypeahead();
        event.preventDefault();
        event.stopPropagation();
        field.open = false;
        summary.focus();
        return;
      }
      const choices = Array.from(field.querySelectorAll(".finder-choice:not(:disabled)"));
      const fromSummary = event.target === summary;
      const index = choices.indexOf(event.target.closest(".finder-choice"));
      if ((!fromSummary && index < 0) || !choices.length) return;
      let next;
      if (event.key === "ArrowDown") next = fromSummary ? 0 : (index + 1) % choices.length;
      if (event.key === "ArrowUp") next = fromSummary ? choices.length - 1 : (index - 1 + choices.length) % choices.length;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = choices.length - 1;
      if (next == null && event.key.length === 1 && event.key !== " " && !event.ctrlKey && !event.altKey && !event.metaKey) {
        if (this.typeaheadField !== field) this.resetTypeahead();
        this.typeaheadField = field;
        const now = Date.now();
        this.typeahead = now - (this.typeaheadTime || 0) > 700 ? event.key : (this.typeahead || "") + event.key;
        this.typeaheadTime = now;
        next = choices.findIndex((choice) => choice.textContent.trim().toLocaleLowerCase().startsWith(this.typeahead.toLocaleLowerCase()));
        if (next < 0) return;
      }
      if (next == null) return;
      event.preventDefault();
      this.closeFields(field);
      field.open = true;
      choices[next].focus();
    }
  };
  var filterManuals = class extends finderControls {
    connectedCallback() {
      if (!this.connectFinder()) return;
      this.systemField = this.querySelector(".chosen-container[data-field-index='1']");
      this.brandField = this.querySelector(".chosen-container[data-field-index='2']");
      this.modelField = this.querySelector(".chosen-container[data-field-index='3']");
      this.template = this.querySelector("template");
      this.loading = this.querySelector(".lds-ring");
      this.brandModels = new WeakMap();
      this.resetFields();
      this.loadData();
    }
    resetFields() {
      this.labelField(this.brandField, "brand", this.message("finderSelectBrand", "Select your brand..."));
      this.labelField(this.modelField, "model", this.message("finderSelectModel", "Select your model..."));
      this.showMessage(this.modelField, this.message("finderChooseBrand", "Choose a brand first."));
      this.setDestination();
      this.closeFields();
    }
    loadData() {
      const restoreFocus = this.brandField.contains(document.activeElement);
      const version = this.requestVersion = (this.requestVersion || 0) + 1;
      this.requestController?.abort();
      this.requestController = new AbortController();
      this.dataReady = false;
      this.loadFailed = false;
      this.resetFields();
      if (restoreFocus) this.brandField.querySelector("summary").focus();
      const loading = this.dataset.loadingMessage || this.message("finderLoading", "Loading brands and models…");
      this.showMessage(this.brandField, loading);
      this.brandField.setAttribute("aria-busy", "true");
      this.loading?.classList.remove("none");
      this.announce(loading);
      this.ready = this.fetchTemplate(this.requestController.signal).then((template) => {
        if (version !== this.requestVersion || !this.isConnected) return;
        this.template.innerHTML = template;
        this.dataReady = true;
        this.renderBrands();
      }).catch((error) => {
        if (version !== this.requestVersion || !this.isConnected || error.name === "AbortError") return;
        this.loadFailed = true;
        this.showLoadError();
      }).finally(() => {
        if (version !== this.requestVersion) return;
        this.brandField.removeAttribute("aria-busy");
        this.loading?.classList.add("none");
      });
      return this.ready;
    }
    async fetchTemplate(signal) {
      // Render the current shop data; a blocked/stale localStorage cache must not break the finder.
      const response = await fetch("?section_id=metaobj-fetch", { signal });
      if (!response.ok) throw new Error("Finder request failed");
      const html = await response.text();
      const parsed = document.createElement("template");
      parsed.innerHTML = html;
      if (!parsed.content.querySelector(".step-2-container")) throw new Error("Finder data unavailable");
      return html;
    }
    showLoadError() {
      const message = this.dataset.errorMessage || this.message("finderError", "We could not load the finder. Please try again.");
      this.showMessage(this.brandField, message);
      const retry = document.createElement("button");
      retry.type = "button";
      retry.className = "finder-retry btn btn-2";
      retry.textContent = this.message("finderRetry", "Try again");
      this.choicesContainer(this.brandField).append(retry);
      this.announce(message);
    }
    selectSystem(button) {
      this.systemField.querySelectorAll(".sys-btn").forEach((system) => {
        system.classList.toggle("active", system === button);
        system.setAttribute("aria-pressed", String(system === button));
      });
      this.resetFields();
      if (this.dataReady) this.renderBrands();
      else if (this.loadFailed) this.showLoadError();
    }
    renderBrands() {
      const selected = this.systemField.querySelector(".sys-btn.active") || this.systemField.querySelector(".sys-btn");
      const type = selected?.dataset.type.trim();
      const selector = type === "RO System" ? ".RO-SYS" : type === "UV System" ? ".UV-SYS" : null;
      const source = selector ? this.template.content.querySelector(`.step-2-container ${selector}`) : null;
      const buttons = Array.from(source?.children || []).filter((element) => element.matches(".chosen-item")).map((element) => {
        const label = element.cloneNode(true);
        label.querySelector(".item-holding")?.remove();
        const button = this.createChoice(label.textContent.trim());
        const models = Array.from(element.querySelectorAll(".item-holding .chosen-item")).map((model) => ({
          name: model.textContent.trim(), url: model.dataset.url || "", position: Number.parseInt(model.dataset.position, 10)
        })).sort((a, b) => (Number.isFinite(a.position) ? a.position : Infinity) - (Number.isFinite(b.position) ? b.position : Infinity));
        this.brandModels.set(button, models);
        return button;
      });
      this.choicesContainer(this.brandField).replaceChildren(...buttons);
      if (!buttons.length) this.showMessage(this.brandField, this.message("finderNoBrands", "No brands are available for this system."));
      this.announce(buttons.length ? this.message("finderSelectBrand", "Select your brand...") : this.message("finderNoBrands", "No brands are available for this system."));
    }
    selectChoice(button) {
      if (button.closest("details") === this.modelField) return this.selectModel(button, this.modelField);
      if (button.closest("details") !== this.brandField) return;
      this.markChoice(button);
      this.labelField(this.brandField, "brand", button.textContent.trim());
      this.labelField(this.modelField, "model", this.message("finderSelectModel", "Select your model..."));
      const models = this.brandModels.get(button) || [];
      this.renderModels(this.modelField, models);
      this.closeFields();
      (models.length ? this.modelField : this.brandField).querySelector("summary").focus();
      this.announce(models.length ? this.message("finderReady", "{{ count }} models available. Choose a model.", { count: models.length }) : this.message("finderNoModels", "No models are available for this brand."));
    }
  };
  if (!customElements.get("filter-manuals")) customElements.define("filter-manuals", filterManuals);

  // app/scripts/common/component/model-search.js
  var modelSearch = class extends finderControls {
    connectedCallback() {
      if (!this.connectFinder()) return;
      this.brandField = this.querySelector("details[data-name='brand']");
      this.modelField = this.querySelector("details[data-name='model']") || this.fields[0];
      this.modelPlaceholder = this.modelField.querySelector(".js-title")?.dataset.placeholder || this.modelField.querySelector(".js-title")?.textContent.trim() || this.message("finderSelectModel", "Select your model...");
      this.labelField(this.modelField, "model", this.modelPlaceholder);
      this.setDestination();
      if (this.brandField) {
        this.type = this.dataset.type;
        this.labelField(this.brandField, "brand", this.brandField.querySelector(".js-title")?.dataset.placeholder || this.message("finderSelectBrand", "Select your brand..."));
        const container = this.choicesContainer(this.brandField);
        const brands = Array.from(container.querySelectorAll(".chosen-item")).map((choice) => choice.dataset.value || choice.textContent.trim());
        container.replaceChildren(...brands.map((brand) => this.createChoice(brand)));
        this.showMessage(this.modelField, this.message("finderChooseBrand", "Choose a brand first."));
        try {
          this.models = JSON.parse(this.querySelector(".object-models").textContent);
          if (!Array.isArray(this.models)) throw new Error("Invalid finder data");
        } catch (_) {
          this.models = [];
          const error = this.message("finderError", "We could not load the finder. Please try again.");
          this.showMessage(this.brandField, error);
          this.announce(error);
        }
      } else {
        const models = Array.from(this.choicesContainer(this.modelField).querySelectorAll(".chosen-item")).map((choice) => ({
          name: choice.textContent.trim(), url: choice.dataset.url || "", position: Number.parseInt(choice.dataset.position, 10)
        })).sort((a, b) => (Number.isFinite(a.position) ? a.position : Infinity) - (Number.isFinite(b.position) ? b.position : Infinity));
        this.renderModels(this.modelField, models);
      }
    }
    selectChoice(button) {
      if (button.closest("details") === this.modelField) return this.selectModel(button, this.modelField);
      if (button.closest("details") !== this.brandField) return;
      this.markChoice(button);
      this.labelField(this.brandField, "brand", button.textContent.trim());
      this.labelField(this.modelField, "model", this.modelPlaceholder);
      const models = this.models.filter((model) => model && model.type === this.type && model.brand === button.textContent.trim());
      const viewAll = models.find((model) => model.name === "View All Models");
      this.renderModels(this.modelField, [...(viewAll ? [viewAll] : []), ...models.filter((model) => model.name !== "View All Models")]);
      this.closeFields();
      (models.length ? this.modelField : this.brandField).querySelector("summary").focus();
      this.announce(models.length ? this.message("finderReady", "{{ count }} models available. Choose a model.", { count: models.length }) : this.message("finderNoModels", "No models are available for this brand."));
    }
  };
  if (!customElements.get("single-search")) customElements.define("single-search", modelSearch);
  if (!customElements.get("brand-search")) customElements.define("brand-search", class extends modelSearch {});

  // app/scripts/theme.js
  var { editor } = theme;
  !editor && header_default.init();
  (function updateHeaderStyle() {
    function checkHrefAndAddParameter() {
      if (localStorage.getItem("utm_source") || window.location.href.includes("utm_source=")) {
        const params = new URL(window.location.href).searchParams;
        const utmSource = localStorage.getItem("utm_source") || params.get("utm_source");
        const links = document.querySelectorAll("a");
        links.forEach((link) => {
          if (link.href.startsWith(window.location.origin) && !link.href.includes(`${window.location.origin}/wpm`)) {
            if (!link.href.includes("utm_source=")) {
              const url = new URL(link.href);
              url.searchParams.set("utm_source", utmSource);
              link.href = url.toString();
            }
          }
        });
      }
    }
    function addObserver() {
      const targetNode = document.body;
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList, observer2) => {
        checkHrefAndAddParameter();
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
      window.addEventListener("beforeunload", () => {
        observer.disconnect();
      });
    }
    checkHrefAndAddParameter();
    addObserver();
  })();
  console.log("theme js loaded");
})();
